
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as d2FzbTpqcy1zdHJpbmc from './Phoebe-composeApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;
let require;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    const module = await import(/* webpackIgnore: true */'node:module');
    const importMeta = import.meta;
    require = module.default.createRequire(importMeta.url);
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.doubleToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_(()->Unit)' : (f) => getCachedJsObject(f, () => wasmExports['__callFunction_(()->Unit)'](f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.JsArray_$external_class_instanceof' : (x) => x instanceof Array,
    'kotlin.js.JsArray_$external_class_get' : () => Array,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js?)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js?)->Js?)'](f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.__convertKotlinClosureToJsClosure_((Js)->Js?)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Js?)'](f, p0)),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.error_$external_fun' : (_this, p0) => _this.error(p0),
    'kotlinx.coroutines.console_$external_prop_getter' : () => console,
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'org.khronos.webgl.getMethodImplForUint8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.setMethodImplForInt8Array' : (obj, index, value) => { obj[index] = value; },
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.slice_$external_fun' : (_this, p0, p1, isDefault0) => _this.slice(p0, isDefault0 ? undefined : p1, ),
    'org.khronos.webgl.Uint8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Uint8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'org.khronos.webgl.byteOffset_$external_prop_getter' : (_this) => _this.byteOffset,
    'org.khronos.webgl.byteLength_$external_prop_getter_1' : (_this) => _this.byteLength,
    'org.khronos.webgl.Uint8Array_$external_class_instanceof' : (x) => x instanceof Uint8Array,
    'org.khronos.webgl.Uint8Array_$external_class_get' : () => Uint8Array,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0) => new Int8Array(p0),
    'org.khronos.webgl.Int8Array_$external_fun_1' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter_1' : (_this) => _this.length,
    'org.khronos.webgl.buffer_$external_prop_getter_1' : (_this) => _this.buffer,
    'org.khronos.webgl.set_$external_fun' : (_this, p0, p1, isDefault0) => _this.set(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.repeat_$external_prop_getter' : (_this) => _this.repeat,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.__convertKotlinClosureToJsClosure_((Js)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Js)->Unit)'](f, p0)),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.clientX_$external_prop_getter' : (_this) => _this.clientX,
    'org.w3c.dom.events.clientY_$external_prop_getter' : (_this) => _this.clientY,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.open_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.open(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Double)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Double)->Unit)'](f, p0)),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.__callJsClosure_((Js)->Unit)' : (f, p0) => f(p0),
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.pathname_$external_prop_getter' : (_this) => _this.pathname,
    'org.w3c.dom.search_$external_prop_getter' : (_this) => _this.search,
    'org.w3c.dom.assign_$external_fun' : (_this, p0) => _this.assign(p0),
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.innerText_$external_prop_setter' : (_this, v) => _this.innerText = v,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.__convertKotlinClosureToJsClosure_((Js?,String,Int,Int,Js?)->Js?)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((Js?,String,Int,Int,Js?)->Js?)'](f, p0, p1, p2, p3, p4)),
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.hasChildNodes_$external_fun' : (_this, ) => _this.hasChildNodes(),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.protocol_$external_prop_getter_1' : (_this) => _this.protocol,
    'org.w3c.dom.binaryType_$external_prop_setter' : (_this, v) => _this.binaryType = v,
    'org.w3c.dom.close_$external_fun' : (_this, p0, p1, isDefault0, isDefault1) => _this.close(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, ),
    'org.w3c.dom.send_$external_fun' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.send_$external_fun_1' : (_this, p0) => _this.send(p0),
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.MessageEvent_$external_class_instanceof' : (x) => x instanceof MessageEvent,
    'org.w3c.dom.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.reason_$external_prop_getter' : (_this) => _this.reason,
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.postMessage_$external_fun' : (_this, p0, p1, isDefault0) => _this.postMessage(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.onLine_$external_prop_getter' : (_this) => _this.onLine,
    'org.w3c.dom.oncanplay_$external_prop_setter' : (_this, v) => _this.oncanplay = v,
    'org.w3c.dom.oncanplaythrough_$external_prop_setter' : (_this, v) => _this.oncanplaythrough = v,
    'org.w3c.dom.ondurationchange_$external_prop_setter' : (_this, v) => _this.ondurationchange = v,
    'org.w3c.dom.onended_$external_prop_getter' : (_this) => _this.onended,
    'org.w3c.dom.onended_$external_prop_setter' : (_this, v) => _this.onended = v,
    'org.w3c.dom.onerror_$external_prop_setter' : (_this, v) => _this.onerror = v,
    'org.w3c.dom.onloadeddata_$external_prop_setter' : (_this, v) => _this.onloadeddata = v,
    'org.w3c.dom.onloadedmetadata_$external_prop_setter' : (_this, v) => _this.onloadedmetadata = v,
    'org.w3c.dom.onpause_$external_prop_setter' : (_this, v) => _this.onpause = v,
    'org.w3c.dom.onplaying_$external_prop_setter' : (_this, v) => _this.onplaying = v,
    'org.w3c.dom.onprogress_$external_prop_setter' : (_this, v) => _this.onprogress = v,
    'org.w3c.dom.onstalled_$external_prop_setter' : (_this, v) => _this.onstalled = v,
    'org.w3c.dom.onsuspend_$external_prop_setter' : (_this, v) => _this.onsuspend = v,
    'org.w3c.dom.ontimeupdate_$external_prop_setter' : (_this, v) => _this.ontimeupdate = v,
    'org.w3c.dom.onwaiting_$external_prop_setter' : (_this, v) => _this.onwaiting = v,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.btoa_$external_fun' : (_this, p0) => _this.btoa(p0),
    'org.w3c.dom.atob_$external_fun' : (_this, p0) => _this.atob(p0),
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.localStorage_$external_prop_getter' : (_this) => _this.localStorage,
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_2' : () => ({}),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'org.w3c.dom.start_$external_fun' : (_this, p0) => _this.start(p0),
    'org.w3c.dom.end_$external_fun' : (_this, p0) => _this.end(p0),
    'org.w3c.dom.HTMLAudioElement_$external_class_instanceof' : (x) => x instanceof HTMLAudioElement,
    'org.w3c.dom.HTMLAudioElement_$external_class_get' : () => HTMLAudioElement,
    'org.w3c.dom.src_$external_prop_setter' : (_this, v) => _this.src = v,
    'org.w3c.dom.crossOrigin_$external_prop_setter' : (_this, v) => _this.crossOrigin = v,
    'org.w3c.dom.preload_$external_prop_setter' : (_this, v) => _this.preload = v,
    'org.w3c.dom.buffered_$external_prop_getter' : (_this) => _this.buffered,
    'org.w3c.dom.currentTime_$external_prop_getter' : (_this) => _this.currentTime,
    'org.w3c.dom.duration_$external_prop_getter' : (_this) => _this.duration,
    'org.w3c.dom.paused_$external_prop_getter' : (_this) => _this.paused,
    'org.w3c.dom.volume_$external_prop_getter' : (_this) => _this.volume,
    'org.w3c.dom.volume_$external_prop_setter' : (_this, v) => _this.volume = v,
    'org.w3c.dom.muted_$external_prop_setter' : (_this, v) => _this.muted = v,
    'org.w3c.dom.load_$external_fun' : (_this, ) => _this.load(),
    'org.w3c.dom.pause_$external_fun' : (_this, ) => _this.pause(),
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.status_$external_prop_getter' : (_this) => _this.status,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.statusText_$external_prop_getter' : (_this) => _this.statusText,
    'org.w3c.fetch.headers_$external_prop_getter' : (_this) => _this.headers,
    'org.w3c.fetch.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.fetch.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.w3c.fetch.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter_1' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.createDefaultContextAttributes' : () => {
        return {
            alpha: 1,
            depth: 1,
            stencil: 8,
            antialias: 0,
            premultipliedAlpha: 1,
            preserveDrawingBuffer: 0,
            preferLowPowerToHighPerformance: 0,
            failIfMajorPerformanceCaveat: 0,
            enableExtensionsByDefault: 1,
            explicitSwapControl: 0,
            renderViaOffscreenBackBuffer: 0,
            majorVersion: 2,
        }
    }
    ,
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.value_$external_prop_setter' : (_this, v) => _this.value = v,
    'androidx.compose.ui.platform.selectionStart_$external_prop_getter' : (_this) => _this.selectionStart,
    'androidx.compose.ui.platform.selectionEnd_$external_prop_getter' : (_this) => _this.selectionEnd,
    'androidx.compose.ui.platform.setSelectionRange_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setSelectionRange(p0, p1, isDefault0 ? undefined : p2, ),
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_getter' : (_this) => _this.textRangeStart,
    'androidx.compose.ui.platform.textRangeStart_$external_prop_setter' : (_this, v) => _this.textRangeStart = v,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_getter' : (_this) => _this.textRangeEnd,
    'androidx.compose.ui.platform.textRangeEnd_$external_prop_setter' : (_this, v) => _this.textRangeEnd = v,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmExports.memory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'kotlinx.io.node.sep_$external_prop_getter' : (_this) => _this.sep,
    'kotlinx.io.getPlatformName' : 
        () => (typeof navigator !== "undefined" && navigator.platform) || "unknown"
    ,
    'kotlinx.io.node.persistModule' : 
        (globalThis.module = (typeof process !== 'undefined') && (process.release.name === 'node') ?
            await import(/* webpackIgnore: true */'node:module') : void 0, () => {})
    ,
    'kotlinx.io.node.getRequire' : () => { 
        const importMeta = import.meta;
        return globalThis.module.default.createRequire(importMeta.url);
    }
    ,
    'kotlinx.io.node.requireModule' : 
        (require, mod) => {
             try {
                 let m = require(mod);
                 if (m) return m;
                 return null;
             } catch (e) {
                 return null;
             }
        }
    ,
    'io.ktor.utils.io.js.decode' : (decoder, buffer) => { try { return decoder.decode(buffer) } catch(e) { return null } },
    'io.ktor.utils.io.js.tryCreateTextDecoder' : (encoding, fatal) => { try { return new TextDecoder(encoding, { fatal: fatal }) } catch(e) { return null } },
    'io.ktor.utils.io.charsets.toJsArrayImpl' : (x) => new Int8Array(x),
    'io.ktor.util.hasNodeApi' : () => 
    (typeof process !== 'undefined' 
        && process.versions != null 
        && process.versions.node != null) ||
    (typeof window !== 'undefined' 
        && typeof window.process !== 'undefined' 
        && window.process.versions != null 
        && window.process.versions.node != null)
    ,
    'io.ktor.util.logging.getKtorLogLevel' : () => process ? process.env.KTOR_LOG_LEVEL : null,
    'io.ktor.util.logging.warn_$external_fun' : (_this, p0) => _this.warn(p0),
    'io.ktor.util.logging.debug_$external_fun' : (_this, p0) => _this.debug(p0),
    'io.ktor.util.logging.console_$external_prop_getter' : () => console,
    'io.ktor.util.date.Date_$external_fun' : () => new Date(),
    'io.ktor.util.date.Date_$external_fun_1' : (p0) => new Date(p0),
    'io.ktor.util.date.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'io.ktor.util.date.getUTCDate_$external_fun' : (_this, ) => _this.getUTCDate(),
    'io.ktor.util.date.getUTCDay_$external_fun' : (_this, ) => _this.getUTCDay(),
    'io.ktor.util.date.getUTCFullYear_$external_fun' : (_this, ) => _this.getUTCFullYear(),
    'io.ktor.util.date.getUTCHours_$external_fun' : (_this, ) => _this.getUTCHours(),
    'io.ktor.util.date.getUTCMinutes_$external_fun' : (_this, ) => _this.getUTCMinutes(),
    'io.ktor.util.date.getUTCMonth_$external_fun' : (_this, ) => _this.getUTCMonth(),
    'io.ktor.util.date.getUTCSeconds_$external_fun' : (_this, ) => _this.getUTCSeconds(),
    'io.ktor.http.locationOrigin' : () => function() {
        var tmpLocation = null
        if (typeof window !== 'undefined') {
          tmpLocation = window.location
        } else if (typeof self !== 'undefined') {
          tmpLocation = self.location
        }
        var origin = ""
        if (tmpLocation) {
          origin = tmpLocation.origin
        }
        return origin && origin != "null" ? origin : "http://localhost"    
    }(),
    'io.ktor.client.engine.js.createBrowserWebSocket' : (urlString_capturingHack, protocols) => new WebSocket(urlString_capturingHack, protocols),
    'io.ktor.client.engine.js.createWebSocketNodeJs' : (socketCtor, urlString_capturingHack, headers_capturingHack, protocols) => new socketCtor(urlString_capturingHack, protocols, { headers: headers_capturingHack }),
    'io.ktor.client.engine.js.getKeys' : (headers) => Array.from(headers.keys()),
    'io.ktor.client.engine.js.eventAsString' : (event) => JSON.stringify(event, ['message', 'target', 'type', 'isTrusted']),
    'io.ktor.client.engine.js.compatibility.abortControllerCtorBrowser' : () => AbortController,
    'io.ktor.client.fetch.body_$external_prop_setter' : (_this, v) => _this.body = v,
    'io.ktor.client.fetch.headers_$external_prop_setter' : (_this, v) => _this.headers = v,
    'io.ktor.client.fetch.method_$external_prop_setter' : (_this, v) => _this.method = v,
    'io.ktor.client.fetch.redirect_$external_prop_setter' : (_this, v) => _this.redirect = v,
    'io.ktor.client.fetch.signal_$external_prop_setter' : (_this, v) => _this.signal = v,
    'io.ktor.client.fetch.signal_$external_prop_getter' : (_this) => _this.signal,
    'io.ktor.client.fetch.abort_$external_fun' : (_this, ) => _this.abort(),
    'io.ktor.client.fetch.fetch_$external_fun' : (p0, p1, isDefault0) => fetch(p0, isDefault0 ? undefined : p1, ),
    'io.ktor.client.fetch.getReader_$external_fun' : (_this, ) => _this.getReader(),
    'io.ktor.client.fetch.cancel_$external_fun' : (_this, p0, isDefault0) => _this.cancel(isDefault0 ? undefined : p0, ),
    'io.ktor.client.fetch.read_$external_fun' : (_this, ) => _this.read(),
    'io.ktor.client.fetch.done_$external_prop_getter' : (_this) => _this.done,
    'io.ktor.client.fetch.value_$external_prop_getter' : (_this) => _this.value,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsString' : (data) => typeof(data) === 'string' ? data : null,
    'io.ktor.client.plugins.websocket.tryGetEventDataAsArrayBuffer' : (data) => data instanceof ArrayBuffer ? data : null,
    'io.ktor.client.utils.makeJsObject' : () => { return {}; },
    'io.ktor.client.utils.makeImport' : (name) => import(name),
    'io.ktor.client.utils.makeJsCall' : (func, arg) => func.apply(null, arg),
    'io.ktor.client.utils.jsObjectAssign' : () => Object.assign,
    'io.ktor.client.utils.makeJsNew' : (ctor) => new ctor(),
    'io.ktor.client.utils.getObjectField' : (obj, name) => obj[name],
    'io.ktor.client.utils.setObjectField' : (obj, name, value) => obj[name]=value,
    'io.ktor.client.utils.toJsArrayImpl' : (x) => new Uint8Array(x),
    'com.phoebe.app.platform.secureRandomValuesJs' : (length) => Array.from(crypto.getRandomValues(new Uint8Array(length))).join(','),
    'com.phoebe.app.platform.webPickVisualizerPresetFiles' : 
        (onDone) => {
          try {
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = '.milk,.json,application/json,text/plain';
            input.multiple = true;
            input.style.display = 'none';
            document.body.appendChild(input);
            input.onchange = async () => {
              const files = Array.from(input.files || []);
              document.body.removeChild(input);
              const parts = [];
              for (const file of files) {
                const name = file.name || 'preset';
                const lower = name.toLowerCase();
                if (!lower.endsWith('.milk') && !lower.endsWith('.json')) continue;
                try {
                  const text = await file.text();
                  parts.push(name + '\u0001' + text);
                } catch (e) {}
              }
              onDone(parts.join('\u0000'));
            };
            input.click();
          } catch (e) {
            onDone('');
          }
        }
        ,
    'com.phoebe.app.platform.__convertKotlinClosureToJsClosure_((String)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((String)->Unit)'](f, p0)),
    'com.phoebe.app.platform.decodeURIComponent' : (value) => decodeURIComponent(value),
    'com.phoebe.app.platform.webDownloadEnsureApi' : 
        () => {
          if (globalThis.__phoebeDownloadApi) return;
          const dbName = "phoebe-downloads";
          const storeName = "files";
          const chunkStoreName = "chunks";
          const writers = new Map();
          const finish = (callback, value) => callback(String(value || ""));
          const fail = (callback, error) => {
            const message = error && error.message ? error.message : String(error || "storage error");
            finish(callback, "ERROR:" + message);
          };
          const objectUrlCache = () =>
            globalThis.__phoebeDownloadObjectUrls || (globalThis.__phoebeDownloadObjectUrls = new Map());
          const revokeObjectUrl = (key) => {
            const cache = objectUrlCache();
            const url = cache.get(key);
            if (url) {
              try { URL.revokeObjectURL(url); } catch (error) {}
              cache.delete(key);
            }
          };
          const audioMimeForName = (name) => {
            const lower = String(name || "").toLowerCase();
            if (lower.endsWith(".mp3") || lower.endsWith(".mpeg") || lower.endsWith(".mpga")) return "audio/mpeg";
            if (lower.endsWith(".m4a") || lower.endsWith(".aac")) return "audio/mp4";
            if (lower.endsWith(".flac")) return "audio/flac";
            if (lower.endsWith(".ogg")) return "audio/ogg";
            if (lower.endsWith(".opus")) return "audio/ogg; codecs=opus";
            if (lower.endsWith(".wav")) return "audio/wav";
            return "audio/*";
          };
          const openDb = () => new Promise((resolve, reject) => {
            const request = indexedDB.open(dbName, 2);
            request.onupgradeneeded = () => {
              const db = request.result;
              if (!db.objectStoreNames.contains(storeName)) db.createObjectStore(storeName, { keyPath: "name" });
              if (!db.objectStoreNames.contains(chunkStoreName)) db.createObjectStore(chunkStoreName, { keyPath: ["name", "index"] });
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
          });
          const chunkRange = (key) => IDBKeyRange.bound([key, 0], [key, Number.MAX_SAFE_INTEGER]);
          const deleteIdbChunks = (chunks, key, reject) => {
            const cursorRequest = chunks.openCursor(chunkRange(key));
            cursorRequest.onsuccess = () => {
              const cursor = cursorRequest.result;
              if (!cursor) return;
              cursor.delete();
              cursor.continue();
            };
            cursorRequest.onerror = () => reject(cursorRequest.error);
          };
          const idbStart = (name) => openDb().then((db) => new Promise((resolve, reject) => {
            const key = String(name || "");
            const tx = db.transaction([storeName, chunkStoreName], "readwrite");
            const files = tx.objectStore(storeName);
            const chunks = tx.objectStore(chunkStoreName);
            files.put({ name: key, size: 0, complete: false, chunkCount: 0 });
            deleteIdbChunks(chunks, key, reject);
            tx.oncomplete = () => { db.close(); resolve(""); };
            tx.onerror = () => { db.close(); reject(tx.error); };
          }));
          const idbAppend = (name, binary) => openDb().then((db) => new Promise((resolve, reject) => {
            const tx = db.transaction([storeName, chunkStoreName], "readwrite");
            const store = tx.objectStore(storeName);
            const chunks = tx.objectStore(chunkStoreName);
            const key = String(name || "");
            const get = store.get(key);
            get.onsuccess = () => {
              const data = String(binary || "");
              const record = get.result || { name: key, size: 0, complete: false, chunkCount: 0 };
              const index = Number(record.chunkCount || 0);
              chunks.put({ name: key, index, binary: data });
              record.chunkCount = index + 1;
              record.size = Number(record.size || 0) + data.length;
              record.complete = false;
              store.put(record);
            };
            get.onerror = () => reject(get.error);
            tx.oncomplete = () => { db.close(); resolve(""); };
            tx.onerror = () => { db.close(); reject(tx.error); };
          }));
          const idbFinish = (name) => openDb().then((db) => new Promise((resolve, reject) => {
            const tx = db.transaction(storeName, "readwrite");
            const store = tx.objectStore(storeName);
            const key = String(name || "");
            const get = store.get(key);
            get.onsuccess = () => {
              const record = get.result || { name: key, chunks: [], size: 0, complete: false };
              record.complete = true;
              store.put(record);
            };
            get.onerror = () => reject(get.error);
            tx.oncomplete = () => { db.close(); resolve(""); };
            tx.onerror = () => { db.close(); reject(tx.error); };
          }));
          const idbDelete = (name) => openDb().then((db) => new Promise((resolve, reject) => {
            const key = String(name || "");
            const tx = db.transaction([storeName, chunkStoreName], "readwrite");
            tx.objectStore(storeName).delete(key);
            const chunks = tx.objectStore(chunkStoreName);
            deleteIdbChunks(chunks, key, reject);
            tx.oncomplete = () => { db.close(); resolve(""); };
            tx.onerror = () => { db.close(); reject(tx.error); };
          }));
          const idbReadBinaryParts = (name) => openDb().then((db) => new Promise((resolve, reject) => {
            const key = String(name || "");
            const tx = db.transaction([storeName, chunkStoreName], "readonly");
            let settled = false;
            const done = (value) => {
              if (settled) return;
              settled = true;
              db.close();
              resolve(value);
            };
            const get = tx.objectStore(storeName).get(key);
            get.onsuccess = () => {
              const record = get.result;
              if (!record || !record.complete) {
                done(null);
                return;
              }
              if (record.chunks) {
                done(record.chunks.map((chunk) => String(chunk || "")));
                return;
              }
              const parts = [];
              const cursorRequest = tx.objectStore(chunkStoreName).openCursor(chunkRange(key));
              cursorRequest.onsuccess = () => {
                const cursor = cursorRequest.result;
                if (!cursor) return;
                parts.push(String(cursor.value && cursor.value.binary || ""));
                cursor.continue();
              };
              cursorRequest.onerror = () => {
                if (!settled) {
                  settled = true;
                  db.close();
                  reject(cursorRequest.error);
                }
              };
              tx.oncomplete = () => done(parts);
            };
            get.onerror = () => {
              if (!settled) {
                settled = true;
                db.close();
                reject(get.error);
              }
            };
            tx.onerror = () => {
              if (!settled) {
                settled = true;
                db.close();
                reject(tx.error);
              }
            };
          }));
          const idbReadBase64 = async (name) => {
            const parts = await idbReadBinaryParts(name);
            return parts ? btoa(parts.join("")) : "";
          };
          const idbReadBlob = async (name) => {
            const parts = await idbReadBinaryParts(name);
            if (!parts || parts.length === 0) return null;
            return new Blob(parts.map(binaryToBytes), { type: audioMimeForName(name) });
          };
          const opfsAvailable = () =>
            typeof navigator !== "undefined" &&
            navigator.storage &&
            typeof navigator.storage.getDirectory === "function";
          const safePart = (part) => {
            const value = String(part || "").replace(/[^A-Za-z0-9._-]+/g, "_").replace(/^_+|_+$/g, "");
            return value || "item";
          };
          const safePathParts = (name) => {
            const parts = String(name || "download").split("/").map(safePart).filter(Boolean);
            return parts.length ? parts : ["download"];
          };
          const opfsParent = async (name, create) => {
            const root = await navigator.storage.getDirectory();
            const parts = safePathParts(name);
            let dir = root;
            for (let index = 0; index < parts.length - 1; index += 1) {
              dir = await dir.getDirectoryHandle(parts[index], { create });
            }
            return { dir, leaf: parts[parts.length - 1] };
          };
          const opfsFileHandle = async (name, create) => {
            const parent = await opfsParent(name, create);
            return parent.dir.getFileHandle(parent.leaf, { create });
          };
          const opfsRemove = async (name) => {
            if (!opfsAvailable()) return;
            try {
              const parent = await opfsParent(name, false);
              await parent.dir.removeEntry(parent.leaf);
            } catch (error) {
              if (!error || error.name !== "NotFoundError") throw error;
            }
          };
          const binaryToBytes = (binary) => {
            const text = String(binary || "");
            const bytes = new Uint8Array(text.length);
            for (let index = 0; index < text.length; index += 1) {
              bytes[index] = text.charCodeAt(index) & 255;
            }
            return bytes;
          };
          const bytesToBase64 = (bytes) => {
            let binary = "";
            const step = 0x8000;
            for (let index = 0; index < bytes.length; index += step) {
              binary += String.fromCharCode.apply(null, bytes.subarray(index, index + step));
            }
            return btoa(binary);
          };
          const opfsStart = async (name) => {
            const key = String(name || "");
            const previous = writers.get(key);
            if (previous) {
              writers.delete(key);
              try {
                await previous.abort();
              } catch (error) {
              }
            }
            await opfsRemove(name);
            const handle = await opfsFileHandle(name, true);
            const writable = await handle.createWritable();
            writers.set(key, writable);
          };
          const opfsAppend = async (name, binary) => {
            const writer = writers.get(String(name || ""));
            if (!writer) throw new Error("Browser file writer is not open.");
            await writer.write(binaryToBytes(binary));
          };
          const opfsFinish = async (name) => {
            const key = String(name || "");
            const writer = writers.get(key);
            if (!writer) return;
            writers.delete(key);
            await writer.close();
          };
          const opfsDelete = async (name) => {
            const key = String(name || "");
            const writer = writers.get(key);
            if (writer) {
              writers.delete(key);
              try {
                await writer.abort();
              } catch (error) {
              }
            }
            await opfsRemove(name);
          };
          const opfsReadBase64 = async (name) => {
            const handle = await opfsFileHandle(name, false);
            const file = await handle.getFile();
            const buffer = await file.arrayBuffer();
            return bytesToBase64(new Uint8Array(buffer));
          };
          const opfsObjectUrl = async (name) => {
            const handle = await opfsFileHandle(name, false);
            const file = await handle.getFile();
            const blob = file.type ? file : new Blob([file], { type: audioMimeForName(name) });
            return URL.createObjectURL(blob);
          };
          const run = (callback, block) => {
            block().then((value) => finish(callback, value)).catch((error) => fail(callback, error));
          };
          globalThis.__phoebeDownloadApi = {
            start: (name, callback) => run(callback, async () => {
              const key = String(name || "");
              revokeObjectUrl(key);
              if (opfsAvailable()) {
                try {
                  await opfsStart(key);
                  await idbDelete(key).catch(() => "");
                  return "";
                } catch (error) {
                  writers.delete(key);
                  await opfsDelete(key).catch(() => "");
                }
              }
              await idbStart(key);
              return "";
            }),
            append: (name, binary, callback) => run(callback, async () => {
              const key = String(name || "");
              if (writers.has(key)) {
                await opfsAppend(key, binary);
              } else {
                await idbAppend(key, binary);
              }
              return "";
            }),
            finish: (name, callback) => run(callback, async () => {
              const key = String(name || "");
              if (writers.has(key)) {
                await opfsFinish(key);
              } else {
                await idbFinish(key);
              }
              return "";
            }),
            delete: (name, callback) => run(callback, async () => {
              const key = String(name || "");
              revokeObjectUrl(key);
              await opfsDelete(key).catch(() => "");
              await idbDelete(key).catch(() => "");
              return "";
            }),
            readBase64: (name, callback) => {
              const key = String(name || "");
              (async () => {
                if (opfsAvailable()) {
                  try {
                    const encoded = await opfsReadBase64(key);
                    if (encoded) return encoded;
                  } catch (error) {
                  }
                }
                return idbReadBase64(key).catch(() => "");
              })().then((value) => finish(callback, value)).catch(() => finish(callback, ""));
            },
            objectUrl: (name, callback) => {
              const key = String(name || "");
              const cache = objectUrlCache();
              const cached = cache.get(key);
              if (cached) {
                finish(callback, cached);
                return;
              }
              (async () => {
                if (opfsAvailable()) {
                  try {
                    const url = await opfsObjectUrl(key);
                    if (url) {
                      cache.set(key, url);
                      return url;
                    }
                  } catch (error) {
                  }
                }
                const blob = await idbReadBlob(key).catch(() => null);
                if (!blob) return "";
                const url = URL.createObjectURL(blob);
                cache.set(key, url);
                return url;
              })().then((value) => finish(callback, value)).catch(() => finish(callback, ""));
            },
          };
        }
        ,
    'com.phoebe.app.platform.webDownloadDelete' : (name, callback) => { globalThis.__phoebeDownloadApi.delete(name, callback); },
    'com.phoebe.app.platform.webDownloadReadBase64' : (name, callback) => { globalThis.__phoebeDownloadApi.readBase64(name, callback); },
    'com.phoebe.app.platform.encodeURIComponent' : (value) => encodeURIComponent(value),
    'com.phoebe.app.platform.webDownloadStart' : (name, callback) => { globalThis.__phoebeDownloadApi.start(name, callback); },
    'com.phoebe.app.platform.webDownloadAppend' : (name, binary, callback) => { globalThis.__phoebeDownloadApi.append(name, binary, callback); },
    'com.phoebe.app.platform.webDownloadFinish' : (name, callback) => { globalThis.__phoebeDownloadApi.finish(name, callback); },
    'com.phoebe.app.platform.browserNotificationsSupported' : () => typeof Notification !== 'undefined',
    'com.phoebe.app.platform.browserNotificationPermission' : () => Notification.permission,
    'com.phoebe.app.platform.showBrowserNotification' : (title, body) => { new Notification(title, { body }); },
    'com.phoebe.app.platform.jsDateNow' : () => Date.now(),
    'com.phoebe.app.platform.wasmDebugBuildEnabled' : 
        () => {
          if (typeof globalThis.PHOEBE_DEBUG === 'boolean') return globalThis.PHOEBE_DEBUG;
          if (typeof location !== 'undefined') {
            const host = location.hostname;
            if (host === 'localhost' || host === '127.0.0.1') return true;
          }
          return false;
        }
        ,
    'com.phoebe.app.platform.webDownloadObjectUrl' : (name, callback) => { globalThis.__phoebeDownloadApi.objectUrl(name, callback); },
    'com.phoebe.app.platform.requestBrowserNotificationPermission' : (callback) => { Notification.requestPermission().then(callback); },
    'com.phoebe.app.platform.webNetworkConnectionType' : 
        () => {
          const connection = (typeof navigator !== 'undefined' && navigator.connection) ? navigator.connection : null;
          return connection && typeof connection.type === 'string' ? String(connection.type) : '';
        }
        ,
    'com.phoebe.app.platform.webNetworkConnectionEffectiveType' : 
        () => {
          const connection = (typeof navigator !== 'undefined' && navigator.connection) ? navigator.connection : null;
          return connection && typeof connection.effectiveType === 'string' ? String(connection.effectiveType) : '';
        }
        ,
    'com.phoebe.app.platform.webNetworkConnectionSaveData' : 
        () => {
          const connection = (typeof navigator !== 'undefined' && navigator.connection) ? navigator.connection : null;
          return !!(connection && connection.saveData);
        }
        ,
    'com.phoebe.app.platform.webNetworkConnectionAddChangeListener' : 
        (callback) => {
          const connection = (typeof navigator !== 'undefined' && navigator.connection) ? navigator.connection : null;
          if (!connection || typeof connection.addEventListener !== 'function') return;
          connection.__phoebeNetworkChange = connection.__phoebeNetworkChange || new Map();
          const handler = () => callback();
          connection.__phoebeNetworkChange.set(callback, handler);
          connection.addEventListener('change', handler);
        }
        ,
    'com.phoebe.app.platform.webNetworkConnectionRemoveChangeListener' : 
        (callback) => {
          const connection = (typeof navigator !== 'undefined' && navigator.connection) ? navigator.connection : null;
          if (!connection || typeof connection.removeEventListener !== 'function') return;
          const map = connection.__phoebeNetworkChange;
          if (!map) return;
          const handler = map.get(callback);
          if (!handler) return;
          connection.removeEventListener('change', handler);
          map.delete(callback);
        }
        ,
    'com.phoebe.app.platform.webSecureCredentialEnsureApi' : 
        () => {
          if (globalThis.__phoebeSecureCredentialStore) return;

          const dbName = "phoebe-secure-credentials";
          const storeName = "keys";
          const keyName = "listenbrainz-token-aes-gcm";
          const storagePrefix = "phoebe.secureCredential.";
          const memory = new Map();
          let cachedKeyPromise = null;

          const finish = (callback, value) => callback(String(value || ""));
          const fail = (callback, error) => {
            const message = error && error.message ? error.message : String(error || "storage error");
            finish(callback, "ERROR:" + message);
          };
          const hasPersistentSupport = () => {
            try {
              if (!globalThis.isSecureContext) return false;
              if (!globalThis.crypto || !crypto.subtle || !crypto.getRandomValues) return false;
              if (!globalThis.indexedDB || !globalThis.localStorage) return false;
              if (!globalThis.TextEncoder || !globalThis.TextDecoder) return false;
              const probeKey = storagePrefix + "__probe";
              localStorage.setItem(probeKey, "1");
              localStorage.removeItem(probeKey);
              return true;
            } catch (error) {
              return false;
            }
          };
          const storageKey = (name) => storagePrefix + String(name || "");
          const openDb = () => new Promise((resolve, reject) => {
            const request = indexedDB.open(dbName, 1);
            request.onupgradeneeded = () => {
              const db = request.result;
              if (!db.objectStoreNames.contains(storeName)) db.createObjectStore(storeName);
            };
            request.onsuccess = () => resolve(request.result);
            request.onerror = () => reject(request.error);
          });
          const idbGet = (name) => openDb().then((db) => new Promise((resolve, reject) => {
            const tx = db.transaction(storeName, "readonly");
            const request = tx.objectStore(storeName).get(name);
            request.onsuccess = () => resolve(request.result || null);
            request.onerror = () => reject(request.error);
            tx.oncomplete = () => db.close();
            tx.onerror = () => { db.close(); reject(tx.error); };
          }));
          const idbPut = (name, value) => openDb().then((db) => new Promise((resolve, reject) => {
            const tx = db.transaction(storeName, "readwrite");
            tx.objectStore(storeName).put(value, name);
            tx.oncomplete = () => { db.close(); resolve(""); };
            tx.onerror = () => { db.close(); reject(tx.error); };
          }));
          const persistentKey = () => {
            if (cachedKeyPromise) return cachedKeyPromise;
            cachedKeyPromise = (async () => {
              const existing = await idbGet(keyName);
              if (existing) return existing;
              const key = await crypto.subtle.generateKey(
                { name: "AES-GCM", length: 256 },
                false,
                ["encrypt", "decrypt"],
              );
              await idbPut(keyName, key);
              return key;
            })().catch((error) => {
              cachedKeyPromise = null;
              throw error;
            });
            return cachedKeyPromise;
          };
          const toBase64 = (bytes) => {
            let binary = "";
            for (let i = 0; i < bytes.length; i += 0x8000) {
              binary += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
            }
            return btoa(binary);
          };
          const fromBase64 = (value) => {
            const binary = atob(String(value || ""));
            const bytes = new Uint8Array(binary.length);
            for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
            return bytes;
          };
          const encrypt = async (value) => {
            const key = await persistentKey();
            const iv = crypto.getRandomValues(new Uint8Array(12));
            const data = new TextEncoder().encode(String(value || ""));
            const encrypted = new Uint8Array(await crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, data));
            return JSON.stringify({ version: 1, iv: toBase64(iv), ciphertext: toBase64(encrypted) });
          };
          const decrypt = async (payload) => {
            const item = JSON.parse(String(payload || ""));
            if (!item || item.version !== 1) throw new Error("Unsupported credential payload.");
            const key = await persistentKey();
            const iv = fromBase64(item.iv);
            const ciphertext = fromBase64(item.ciphertext);
            const decrypted = await crypto.subtle.decrypt({ name: "AES-GCM", iv }, key, ciphertext);
            return new TextDecoder().decode(decrypted);
          };

          globalThis.__phoebeSecureCredentialStore = {
            available: () => hasPersistentSupport() ? "persistent" : "session",
            read: (name, callback) => {
              if (!hasPersistentSupport()) {
                finish(callback, memory.has(name) ? "VALUE:" + encodeURIComponent(memory.get(name)) : "MISSING");
                return;
              }
              const key = storageKey(name);
              let payload = null;
              try {
                payload = localStorage.getItem(key);
              } catch (error) {
                fail(callback, error);
                return;
              }
              if (!payload) {
                finish(callback, "MISSING");
                return;
              }
              decrypt(payload)
                .then((value) => finish(callback, "VALUE:" + encodeURIComponent(value)))
                .catch(() => {
                  try { localStorage.removeItem(key); } catch (error) {}
                  finish(callback, "MISSING");
                });
            },
            write: (name, value, callback) => {
              if (!hasPersistentSupport()) {
                memory.set(name, String(value || ""));
                finish(callback, "OK");
                return;
              }
              encrypt(value)
                .then((payload) => {
                  localStorage.setItem(storageKey(name), payload);
                  finish(callback, "OK");
                })
                .catch((error) => fail(callback, error));
            },
            delete: (name, callback) => {
              memory.delete(name);
              if (hasPersistentSupport()) {
                try {
                  localStorage.removeItem(storageKey(name));
                } catch (error) {
                  fail(callback, error);
                  return;
                }
              }
              finish(callback, "OK");
            },
          };
        }
        ,
    'com.phoebe.app.platform.webSecureCredentialAvailability' : () => globalThis.__phoebeSecureCredentialStore.available(),
    'com.phoebe.app.platform.webSecureCredentialRead' : (name, callback) => { globalThis.__phoebeSecureCredentialStore.read(name, callback); },
    'com.phoebe.app.platform.decodeURIComponent_1' : (value) => decodeURIComponent(value),
    'com.phoebe.app.platform.webSecureCredentialWrite' : (name, value, callback) => { globalThis.__phoebeSecureCredentialStore.write(name, value, callback); },
    'com.phoebe.app.platform.webSecureCredentialDelete' : (name, callback) => { globalThis.__phoebeSecureCredentialStore.delete(name, callback); },
    'com.phoebe.app.telemetry.installGlobalErrorHandlers' : 
        (callback) => {
          if (globalThis.__phoebeSentryGlobalHandlersInstalled) return;
          globalThis.__phoebeSentryGlobalHandlersInstalled = true;
          const url = () => typeof location !== "undefined" ? String(location.href || "") : "";
          const userAgent = () => typeof navigator !== "undefined" ? String(navigator.userAgent || "") : "";
          const errorMessage = (error, fallback) => {
            if (error && error.message) return String(error.message);
            return String(fallback || error || "Unknown browser error");
          };
          const errorType = (error, fallback) => {
            if (error && error.name) return String(error.name);
            return String(fallback || "Error");
          };
          const errorStack = (error) => error && error.stack ? String(error.stack) : "";
          window.addEventListener("error", (event) => {
            const error = event.error;
            const message = errorMessage(error, event.message);
            callback(message, errorType(error, "Error"), errorStack(error), url(), userAgent());
          });
          window.addEventListener("unhandledrejection", (event) => {
            const reason = event.reason;
            const message = errorMessage(reason, reason);
            callback(message, errorType(reason, "UnhandledRejection"), errorStack(reason), url(), userAgent());
          });
        }
        ,
    'com.phoebe.app.telemetry.__convertKotlinClosureToJsClosure_((String,String,String,String,String)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((String,String,String,String,String)->Unit)'](f, p0, p1, p2, p3, p4)),
    'com.phoebe.app.telemetry.timestampSeconds' : () => Date.now() / 1000,
    'com.phoebe.app.telemetry.sendSentryEnvelope' : 
        (endpoint, body) => {
          try {
            const payload = String(body || "");
            if (typeof navigator !== "undefined" && navigator.sendBeacon && payload.length < 60000) {
              const blob = new Blob([payload], { type: "text/plain;charset=UTF-8" });
              if (navigator.sendBeacon(endpoint, blob)) return;
            }
            if (typeof fetch !== "undefined") {
              fetch(endpoint, {
                method: "POST",
                body: payload,
                keepalive: true,
                headers: { "Content-Type": "text/plain;charset=UTF-8" },
              }).catch(() => {});
            }
          } catch (_error) {}
        }
        ,
    'app.cash.sqldelight.driver.worker.api.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'app.cash.sqldelight.driver.worker.api.action_$external_prop_setter' : (_this, v) => _this.action = v,
    'app.cash.sqldelight.driver.worker.api.sql_$external_prop_setter' : (_this, v) => _this.sql = v,
    'app.cash.sqldelight.driver.worker.api.params_$external_prop_setter' : (_this, v) => _this.params = v,
    'app.cash.sqldelight.driver.worker.api.error_$external_prop_getter' : (_this) => _this.error,
    'app.cash.sqldelight.driver.worker.api.id_$external_prop_getter' : (_this) => _this.id,
    'app.cash.sqldelight.driver.worker.api.results_$external_prop_getter' : (_this) => _this.results,
    'app.cash.sqldelight.driver.worker.api.values_$external_prop_getter' : (_this) => _this.values,
    'app.cash.sqldelight.driver.worker.util.jsonStringify_js_code' : (value, replacer, space) => JSON.stringify(value, replacer, space),
    'app.cash.sqldelight.driver.worker.util.objectEntries' : (value) => Object.entries(value),
    'app.cash.sqldelight.driver.worker.util.instantiateObject' : () => ({}),
    'app.cash.sqldelight.driver.worker.util.isArray' : (value) => Array.isArray(value),
    'app.cash.sqldelight.driver.worker.util.jsArrayPush' : (array, value) => { array.push(value) },
    'com.phoebe.app.data.db.createPersistentSqlWorker' : 
        (legacyRevision, debug) => {
          const url = new URL('phoebe-sqljs.worker.js', document.baseURI || location.href);
          if (legacyRevision != null) url.searchParams.set('legacyRevision', String(legacyRevision));
          if (debug) url.searchParams.set('debug', '1');
          return new Worker(url.toString());
        }
        ,
    'com.phoebe.app.sources.webPickLocalFolder' : 
        (callback) => {
            const ensureStore = () => globalThis.__phoebeLocalFileStore ||
                (globalThis.__phoebeLocalFileStore = { folders: new Map(), files: new Map() });
            const store = ensureStore();
            const audioExt = new Set(["mp3", "m4a", "flac", "wav", "aac", "ogg", "opus"]);
            let input = null;
            let completed = false;
            const finish = (value) => {
                if (completed) return;
                completed = true;
                if (input) {
                    input.onchange = null;
                    input.oncancel = null;
                    try { input.remove(); } catch (_) {}
                }
                callback(value || "");
            };
            const makeEntry = (file, relativePath, folderLabel) => {
                const raw = String(relativePath || file?.name || "track").replace(/\\/g, "/").replace(/^\/+/, "");
                const parts = raw.split("/").filter(Boolean);
                const fallbackName = String(file.name || "track");
                const cleanRelativePath = (parts.join("/") || fallbackName).replace(/^\/+/, "");
                const name = cleanRelativePath.split("/").filter(Boolean).pop() || fallbackName;
                const parentPath = cleanRelativePath.split("/").slice(0, -1).join("/");
                const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
                return { file, folderLabel: folderLabel || "Local files", relativePath: cleanRelativePath, name, parentPath, ext };
            };
            const commitEntries = (allEntries, folderLabelFallback) => {
                const audioEntries = allEntries.filter((entry) =>
                    audioExt.has(entry.ext) || String(entry.file.type || "").startsWith("audio/")
                );
                if (!audioEntries.length) {
                    return "";
                }
                const folderLabel = folderLabelFallback || allEntries[0]?.folderLabel || audioEntries[0].folderLabel || "Local files";
                const id = "web-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2);
                const rootUri = "phoebe-web-folder://" + id + "/" + encodeURIComponent(folderLabel);
                const textFiles = new Map();
                for (const entry of allEntries) {
                    if (entry.ext === "lrc" || entry.ext === "txt") {
                        textFiles.set(entry.relativePath.toLowerCase(), entry);
                    }
                }
                const files = audioEntries.map((entry) => {
                    const encodedPath = entry.relativePath.split("/").map(encodeURIComponent).join("/");
                    const uri = "phoebe-web-file://" + id + "/" + encodedPath;
                    const stored = { ...entry, folderId: id, folderLabel, uri, objectUrl: null };
                    store.files.set(uri, stored);
                    return stored;
                }).sort((left, right) => left.uri.localeCompare(right.uri));
                store.folders.set(id, { id, rootUri, label: folderLabel, files, textFiles });
                return rootUri;
            };
            const chooseWithInput = () => {
                input = document.createElement("input");
                input.type = "file";
                input.multiple = true;
                input.accept = ".mp3,.m4a,.flac,.wav,.aac,.ogg,.opus,audio/*";
                input.style.display = "none";
                input.setAttribute("webkitdirectory", "");
                input.setAttribute("directory", "");
                input.onchange = () => {
                    const picked = Array.from(input.files || []);
                    if (!picked.length) {
                        finish("");
                        return;
                    }
                    const allEntries = picked.map((file) => {
                        const raw = String(file.webkitRelativePath || file.name || "track").replace(/\\/g, "/").replace(/^\/+/, "");
                        const parts = raw.split("/").filter(Boolean);
                        const folderLabel = parts.length > 1 ? parts[0] : "Local files";
                        const relativePath = (parts.length > 1 ? parts.slice(1) : parts).join("/") || file.name || "track";
                        return makeEntry(file, relativePath, folderLabel);
                    });
                    finish(commitEntries(allEntries, null));
                };
                input.oncancel = () => finish("");
                document.body.appendChild(input);
                input.click();
            };
            const chooseWithDirectoryPicker = async () => {
                if (typeof globalThis.showDirectoryPicker !== "function") return false;
                let directory;
                try {
                    directory = await globalThis.showDirectoryPicker({ mode: "read" });
                } catch (error) {
                    if (error && error.name === "AbortError") {
                        finish("");
                        return true;
                    }
                    console.warn("Phoebe local folder picker failed; falling back to file input.", error);
                    return false;
                }
                const folderLabel = String(directory.name || "Local files");
                const allEntries = [];
                const walk = async (dir, prefix) => {
                    for await (const item of dir.entries()) {
                        const name = item[0];
                        const handle = item[1];
                        const path = prefix ? prefix + "/" + name : name;
                        if (handle.kind === "directory") {
                            await walk(handle, path);
                        } else if (handle.kind === "file") {
                            const file = await handle.getFile();
                            allEntries.push(makeEntry(file, path, folderLabel));
                        }
                    }
                };
                try {
                    await walk(directory, "");
                    finish(commitEntries(allEntries, folderLabel));
                } catch (error) {
                    console.warn("Phoebe could not read the selected local folder.", error);
                    finish("");
                }
                return true;
            };
            chooseWithDirectoryPicker()
                .then((handled) => {
                    if (!handled && !completed) chooseWithInput();
                })
                .catch((error) => {
                    console.warn("Phoebe local folder picker failed; falling back to file input.", error);
                    if (!completed) chooseWithInput();
                });
        }
        ,
    'com.phoebe.app.sources.webListLocalAudioFiles' : 
        (rootUri) => {
            const store = globalThis.__phoebeLocalFileStore;
            const match = /^phoebe-web-folder:\/\/([^/]+)/.exec(String(rootUri || ""));
            const folder = match && store?.folders?.get(match[1]);
            if (!folder) return "[]";
            return JSON.stringify(folder.files.map((entry) => ({
                uri: entry.uri,
                sizeBytes: Number(entry.file.size || 0),
                modifiedAtMs: Number(entry.file.lastModified || 0),
                filepath: entry.name || entry.relativePath
            })));
        }
        ,
    'com.phoebe.app.sources.webLocalFileExists' : 
        (uri) => {
            const store = globalThis.__phoebeLocalFileStore;
            return !!store?.files?.has(String(uri || ""));
        }
        ,
    'com.phoebe.app.sources.webResolveLocalFileUri' : 
        (uri) => {
            const store = globalThis.__phoebeLocalFileStore;
            const entry = store?.files?.get(String(uri || ""));
            if (!entry) return "";
            if (!entry.objectUrl) {
                entry.objectUrl = URL.createObjectURL(entry.file);
            }
            return entry.objectUrl;
        }
        ,
    'com.phoebe.app.sources.webReadLocalAudioMetadata' : 
        (uri, callback) => {
            const store = globalThis.__phoebeLocalFileStore;
            const entry = store?.files?.get(String(uri || ""));
            if (!entry) {
                callback("");
                return;
            }
            const ext = entry.ext || "";
            const title = String(entry.name || "").replace(/\.[^/.]+$/, "");
            const album = entry.parentPath ? entry.parentPath.split("/").pop() : entry.folderLabel;
            const result = {
                title,
                artist: null,
                album,
                durationMs: 0,
                audioCodec: ext || null
            };
            const readSyncSafe = (bytes, offset) =>
                ((bytes[offset] & 0x7f) << 21) |
                ((bytes[offset + 1] & 0x7f) << 14) |
                ((bytes[offset + 2] & 0x7f) << 7) |
                (bytes[offset + 3] & 0x7f);
            const readUint32 = (bytes, offset) =>
                (bytes[offset] << 24) |
                (bytes[offset + 1] << 16) |
                (bytes[offset + 2] << 8) |
                bytes[offset + 3];
            const decodeText = (bytes) => {
                if (!bytes || !bytes.length) return null;
                const encoding = bytes[0];
                let data = bytes.slice(1);
                let decoder = "iso-8859-1";
                if (encoding === 1) {
                    if (data.length >= 2 && data[0] === 0xff && data[1] === 0xfe) {
                        decoder = "utf-16le";
                        data = data.slice(2);
                    } else if (data.length >= 2 && data[0] === 0xfe && data[1] === 0xff) {
                        decoder = "utf-16be";
                        data = data.slice(2);
                    } else {
                        decoder = "utf-16";
                    }
                } else if (encoding === 2) {
                    decoder = "utf-16be";
                } else if (encoding === 3) {
                    decoder = "utf-8";
                }
                try {
                    return new TextDecoder(decoder)
                        .decode(data)
                        .replace(/\u0000+$/g, "")
                        .trim() || null;
                } catch (_) {
                    return null;
                }
            };
            const parseId3Tags = async (file) => {
                if (!file || !String(file.name || "").toLowerCase().endsWith(".mp3")) return {};
                const head = new Uint8Array(await file.slice(0, Math.min(file.size, 10)).arrayBuffer());
                if (head.length < 10 || head[0] !== 0x49 || head[1] !== 0x44 || head[2] !== 0x33) return {};
                const major = head[3];
                const tagSize = readSyncSafe(head, 6);
                const tagBytes = new Uint8Array(await file.slice(0, Math.min(file.size, tagSize + 10)).arrayBuffer());
                const tags = {};
                let offset = 10;
                const textFrameMap = {
                    TIT2: "title",
                    TPE1: "artist",
                    TPE2: "artist",
                    TALB: "album",
                    TYER: "year",
                    TDRC: "year",
                    TCON: "genre",
                    TMOO: "mood"
                };
                while (offset + 10 <= tagBytes.length) {
                    const id = String.fromCharCode(tagBytes[offset], tagBytes[offset + 1], tagBytes[offset + 2], tagBytes[offset + 3]);
                    if (!/^[A-Z0-9]{4}$/.test(id)) break;
                    const frameSize = major === 4 ? readSyncSafe(tagBytes, offset + 4) : readUint32(tagBytes, offset + 4);
                    if (frameSize <= 0 || offset + 10 + frameSize > tagBytes.length) break;
                    const target = textFrameMap[id];
                    if (target && (target !== "artist" || !tags.artist)) {
                        const value = decodeText(tagBytes.slice(offset + 10, offset + 10 + frameSize));
                        if (value) tags[target] = value;
                    }
                    offset += 10 + frameSize;
                }
                return tags;
            };
            let tagsDone = false;
            let durationDone = false;
            let settled = false;
            const maybeFinish = () => {
                if (tagsDone && durationDone) finish();
            };
            if (!entry.objectUrl) {
                entry.objectUrl = URL.createObjectURL(entry.file);
            }
            const audio = document.createElement("audio");
            const finish = () => {
                if (settled) return;
                settled = true;
                clearTimeout(timer);
                audio.onloadedmetadata = null;
                audio.onerror = null;
                audio.removeAttribute("src");
                try { audio.load(); } catch (_) {}
                callback(JSON.stringify(result));
            };
            parseId3Tags(entry.file)
                .then((tags) => {
                    if (tags.title) result.title = tags.title;
                    if (tags.artist) result.artist = tags.artist;
                    if (tags.album) result.album = tags.album;
                    if (tags.year) result.year = tags.year;
                    if (tags.genre) result.genre = tags.genre;
                    if (tags.mood) result.mood = tags.mood;
                })
                .catch((error) => console.warn("Phoebe could not read local ID3 tags.", error))
                .finally(() => {
                    tagsDone = true;
                    maybeFinish();
                });
            const timer = setTimeout(() => {
                durationDone = true;
                maybeFinish();
            }, 2500);
            audio.preload = "metadata";
            audio.onloadedmetadata = () => {
                if (Number.isFinite(audio.duration) && audio.duration > 0) {
                    result.durationMs = Math.round(audio.duration * 1000);
                }
                durationDone = true;
                maybeFinish();
            };
            audio.onerror = () => {
                durationDone = true;
                maybeFinish();
            };
            try {
                audio.src = entry.objectUrl;
                audio.load();
            } catch (_) {
                durationDone = true;
                maybeFinish();
            }
        }
        ,
    'com.phoebe.app.sources.webReadLocalTextSidecar' : 
        (uri, callback) => {
            const store = globalThis.__phoebeLocalFileStore;
            const entry = store?.files?.get(String(uri || ""));
            const folder = entry && store?.folders?.get(entry.folderId);
            if (!entry || !folder?.textFiles) {
                callback("");
                return;
            }
            const stem = entry.relativePath.replace(/\.[^/.]+$/, "").toLowerCase();
            const sidecar = folder.textFiles.get(stem + ".lrc") || folder.textFiles.get(stem + ".txt");
            if (!sidecar) {
                callback("");
                return;
            }
            sidecar.file.text()
                .then((text) => callback(String(text || "")))
                .catch(() => callback(""));
        }
        ,
    'io.ktor.network.sockets.nodejs.createConnection_$external_fun' : (_this, p0) => _this.createConnection(p0),
    'io.ktor.network.sockets.nodejs.createServer_$external_fun' : (_this, p0) => _this.createServer(p0),
    'io.ktor.network.sockets.nodejs.localAddress_$external_prop_getter' : (_this) => _this.localAddress,
    'io.ktor.network.sockets.nodejs.localPort_$external_prop_getter' : (_this) => _this.localPort,
    'io.ktor.network.sockets.nodejs.remoteAddress_$external_prop_getter' : (_this) => _this.remoteAddress,
    'io.ktor.network.sockets.nodejs.remotePort_$external_prop_getter' : (_this) => _this.remotePort,
    'io.ktor.network.sockets.nodejs.write_$external_fun' : (_this, p0) => _this.write(p0),
    'io.ktor.network.sockets.nodejs.destroy_$external_fun' : (_this, p0) => _this.destroy(p0),
    'io.ktor.network.sockets.nodejs.end_$external_fun' : (_this, p0) => _this.end(p0),
    'io.ktor.network.sockets.nodejs.on_$external_fun' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.__convertKotlinClosureToJsClosure_((Boolean)->Unit)' : (f) => getCachedJsObject(f, (p0) => wasmExports['__callFunction_((Boolean)->Unit)'](f, p0)),
    'io.ktor.network.sockets.nodejs.on_$external_fun_1' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.on_$external_fun_2' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.on_$external_fun_3' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.timeout_$external_prop_setter' : (_this, v) => _this.timeout = v,
    'io.ktor.network.sockets.nodejs.address_$external_fun' : (_this, ) => _this.address(),
    'io.ktor.network.sockets.nodejs.listen_$external_fun' : (_this, p0) => _this.listen(p0),
    'io.ktor.network.sockets.nodejs.close_$external_fun' : (_this, ) => _this.close(),
    'io.ktor.network.sockets.nodejs.on_$external_fun_4' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.on_$external_fun_5' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.on_$external_fun_6' : (_this, p0, p1) => _this.on(p0, p1),
    'io.ktor.network.sockets.nodejs.message_$external_prop_getter' : (_this) => _this.message,
    'io.ktor.network.sockets.nodejs.port_$external_prop_setter' : (_this, v) => _this.port = v,
    'io.ktor.network.sockets.nodejs.host_$external_prop_setter' : (_this, v) => _this.host = v,
    'io.ktor.network.sockets.nodejs.path_$external_prop_setter' : (_this, v) => _this.path = v,
    'io.ktor.network.sockets.nodejs.port_$external_prop_setter_1' : (_this, v) => _this.port = v,
    'io.ktor.network.sockets.nodejs.host_$external_prop_setter_1' : (_this, v) => _this.host = v,
    'io.ktor.network.sockets.nodejs.noDelay_$external_prop_setter' : (_this, v) => _this.noDelay = v,
    'io.ktor.network.sockets.nodejs.keepAlive_$external_prop_setter' : (_this, v) => _this.keepAlive = v,
    'io.ktor.network.sockets.nodejs.path_$external_prop_setter_1' : (_this, v) => _this.path = v,
    'io.ktor.network.sockets.nodejs.address_$external_prop_getter' : (_this) => _this.address,
    'io.ktor.network.sockets.nodejs.port_$external_prop_getter' : (_this) => _this.port,
    'io.ktor.network.sockets.nodejs.nodeNet' : () => eval('require')('node:net'),
    'io.ktor.network.sockets.nodejs.jsError' : (message) => (new Error(message)),
    'io.ktor.network.sockets.nodejs.createJsObject' : () => ({}),
    'io.ktor.network.sockets.nodejs.jsTypeOf' : (obj) => (typeof obj),
    'com.phoebe.app.player.isWebAudioEnded' : (audio) => !!(audio && audio.ended),
    'com.phoebe.app.player.isWebAudioAtEnd' : (audio) => {
            if (!audio) return false;
            if (audio.ended) return true;
            const duration = Number(audio.duration);
            const position = Number(audio.currentTime);
            if (!Number.isFinite(duration) || duration <= 0 || !Number.isFinite(position)) return false;
            return position + 0.25 >= duration;
        },
    'com.phoebe.app.player.stopWebAudioAnalysis' : (audio) => {
            const analyses = globalThis.__phoebeAudioAnalyses;
            const entry = analyses?.get(audio);
            if (!entry) return;
            try { clearInterval(entry.timer); } catch (_) {}
            try { entry.input.disconnect(entry.analyser); } catch (_) {}
            try { entry.analyser.disconnect(); } catch (_) {}
            analyses.delete(audio);
        },
    'com.phoebe.app.player.clearWebAudioEventHandlers' : (audio) => {
            if (!audio) return;
            audio.onloadedmetadata = null;
            audio.onloadeddata = null;
            audio.ondurationchange = null;
            audio.onplaying = null;
            audio.onpause = null;
            audio.onwaiting = null;
            audio.onstalled = null;
            audio.oncanplay = null;
            audio.oncanplaythrough = null;
            audio.onprogress = null;
            audio.onsuspend = null;
            audio.ontimeupdate = null;
            audio.onended = null;
            audio.onerror = null;
        },
    'com.phoebe.app.player.cancelWebAudioPrefetch' : () => {},
    'com.phoebe.app.player.releaseWebAudioMediaBuffers' : (audio) => {
            if (!audio) return;
            try { audio.pause(); } catch (_) {}
            audio.removeAttribute("src");
            audio.src = "";
            try { audio.load(); } catch (_) {}
        },
    'com.phoebe.app.player.teardownWebAudioRouting' : (audio) => {
            if (!audio) return;
            const eq = globalThis.__phoebeEqualizer;
            if (eq && eq.audio === audio) {
                try { eq.source.disconnect(); } catch (_) {}
                for (const node of eq.nodes || []) {
                    try { node.disconnect(); } catch (_) {}
                }
                if (eq.gain) {
                    try { eq.gain.disconnect(); } catch (_) {}
                }
                if (eq.context && typeof eq.context.close === "function") {
                    try { eq.context.close(); } catch (_) {}
                }
                globalThis.__phoebeEqualizer = null;
            }
            const gains = globalThis.__phoebeCrossfadeGains;
            const entry = gains?.get(audio);
            if (entry) {
                try { entry.source.disconnect(); } catch (_) {}
                try { entry.gain.disconnect(); } catch (_) {}
                if (entry.context && typeof entry.context.close === "function") {
                    try { entry.context.close(); } catch (_) {}
                }
                gains.delete(audio);
            }
        },
    'com.phoebe.app.player.isWebEqualizerAttached' : (audio) => {
            const eq = globalThis.__phoebeEqualizer;
            return !!eq && eq.audio === audio && !!eq.source;
        },
    'com.phoebe.app.player.disposeWebAudioElement' : (audio) => {
            if (!audio) return;
            const analyses = globalThis.__phoebeAudioAnalyses;
            const analysis = analyses?.get(audio);
            if (analysis) {
                try { clearInterval(analysis.timer); } catch (_) {}
                try { analysis.input.disconnect(analysis.analyser); } catch (_) {}
                try { analysis.analyser.disconnect(); } catch (_) {}
                analyses.delete(audio);
            }
            const eq = globalThis.__phoebeEqualizer;
            if (eq && eq.audio === audio) {
                try { eq.source.disconnect(); } catch (_) {}
                for (const node of eq.nodes || []) {
                    try { node.disconnect(); } catch (_) {}
                }
                if (eq.gain) {
                    try { eq.gain.disconnect(); } catch (_) {}
                }
                if (eq.context && typeof eq.context.close === "function") {
                    try { eq.context.close(); } catch (_) {}
                }
                globalThis.__phoebeEqualizer = null;
            }
            const gains = globalThis.__phoebeCrossfadeGains;
            const entry = gains?.get(audio);
            if (entry) {
                try { entry.source.disconnect(); } catch (_) {}
                try { entry.gain.disconnect(); } catch (_) {}
                if (entry.context && typeof entry.context.close === "function") {
                    try { entry.context.close(); } catch (_) {}
                }
                gains.delete(audio);
            }
            try { audio.pause(); } catch (_) {}
            audio.removeAttribute("src");
            audio.src = "";
            try { audio.load(); } catch (_) {}
            audio.onloadedmetadata = null;
            audio.onloadeddata = null;
            audio.ondurationchange = null;
            audio.onplaying = null;
            audio.onpause = null;
            audio.onwaiting = null;
            audio.onstalled = null;
            audio.oncanplay = null;
            audio.oncanplaythrough = null;
            audio.onprogress = null;
            audio.onsuspend = null;
            audio.ontimeupdate = null;
            audio.onended = null;
            audio.onerror = null;
        },
    'com.phoebe.app.player.setWebAudioCurrentTime' : (audio, seconds) => {
            try {
                if (!audio || !Number.isFinite(seconds)) return false;
                audio.currentTime = Math.max(0, seconds);
                return true;
            } catch (error) {
                console.warn("Phoebe web audio seek failed.", error);
                return false;
            }
        },
    'com.phoebe.app.player.setWebAudioOutputGain' : (audio, gainValue, create) => {
            if (!audio) return false;
            const gain = Math.max(0, Math.min(1, Number(gainValue) || 0));
            const eq = globalThis.__phoebeEqualizer;
            if (eq && eq.audio === audio && eq.source) {
                if (!eq.gain) {
                    eq.gain = eq.context.createGain();
                }
                eq.gainValue = gain;
                try { eq.context.resume?.(); } catch (_) {}
                try { eq.gain.gain.setValueAtTime(gain, eq.context.currentTime || 0); } catch (_) {
                    eq.gain.gain.value = gain;
                }
                return true;
            }
            let gains = globalThis.__phoebeCrossfadeGains;
            if (!gains) {
                gains = new Map();
                globalThis.__phoebeCrossfadeGains = gains;
            }
            let entry = gains.get(audio);
            if (!entry && create) {
                const Ctx = globalThis.AudioContext || globalThis.webkitAudioContext;
                if (!Ctx) return false;
                const context = eq?.context || new Ctx();
                let source;
                try {
                    source = context.createMediaElementSource(audio);
                } catch (error) {
                    return false;
                }
                const gainNode = context.createGain();
                source.connect(gainNode);
                gainNode.connect(context.destination);
                entry = { context, source, gain: gainNode };
                gains.set(audio, entry);
            }
            if (!entry) return false;
            try { entry.context.resume?.(); } catch (_) {}
            try { entry.gain.gain.setValueAtTime(gain, entry.context.currentTime || 0); } catch (_) {
                entry.gain.gain.value = gain;
            }
            return true;
        },
    'com.phoebe.app.player.playWebAudio' : (audio, onFailure) => {
            try {
                if (audio) {
                    globalThis.__phoebeActiveAudio = audio;
                }
                const eq = globalThis.__phoebeEqualizer;
                if (eq && eq.audio === audio && eq.source) {
                    eq.context?.resume?.();
                }
                const playResult = audio.play();
                if (playResult && typeof playResult.catch === "function") {
                    playResult.catch((error) => {
                        const message = error?.message || error?.name || "Web audio playback failed.";
                        console.warn("Phoebe web audio playback was blocked or failed.", error);
                        try { onFailure(String(message)); } catch (_) {}
                    });
                }
            } catch (error) {
                console.warn("Phoebe web audio playback failed.", error);
                const message = error?.message || error?.name || "Web audio playback failed.";
                try { onFailure(String(message)); } catch (_) {}
            }
        },
    'com.phoebe.app.player.webAudioErrorMessage' : (audio) => {
            const error = audio && audio.error;
            if (!error) return "";
            const code = Number(error.code || 0);
            const names = {
                1: "MEDIA_ERR_ABORTED",
                2: "MEDIA_ERR_NETWORK",
                3: "MEDIA_ERR_DECODE",
                4: "MEDIA_ERR_SRC_NOT_SUPPORTED"
            };
            return names[code] || ("HTMLMediaElement error " + code);
        },
    'com.phoebe.app.player.prepareWebEqualizerAudio' : (audio, enabled) => {
            if (!audio) return;
            if (enabled) {
                audio.crossOrigin = "anonymous";
            }
        },
    'com.phoebe.app.player.applyWebEqualizer' : (audio, payload) => {
            const profile = JSON.parse(payload);
            if (!audio) return;
            const Ctx = globalThis.AudioContext || globalThis.webkitAudioContext;
            if (!Ctx) return;
            const active = profile.enabled && profile.gains?.some((gain) => Math.abs(gain) > 0.001);
            const crossfadeGains = globalThis.__phoebeCrossfadeGains;
            const crossfade = crossfadeGains?.get(audio);
            let eq = globalThis.__phoebeEqualizer;
            if (!active && (!eq || eq.audio !== audio) && !crossfade) return;
            if (!eq || eq.audio !== audio) {
                const context = crossfade?.context || eq?.context || new Ctx();
                let source;
                try {
                    source = crossfade?.source || context.createMediaElementSource(audio);
                } catch (error) {
                    // A media element can only have one source node. Reuse the previous one if it exists.
                    if (!eq || eq.audio !== audio || !eq.source) return;
                    source = eq.source;
                }
                const gainValue = Number(crossfade?.gain?.gain?.value ?? eq?.gainValue ?? 1);
                if (crossfade) {
                    try { crossfade.gain.disconnect(); } catch (_) {}
                    crossfadeGains?.delete(audio);
                }
                eq = { audio, context, source, nodes: [], gain: null, gainValue: Number.isFinite(gainValue) ? gainValue : 1 };
                globalThis.__phoebeEqualizer = eq;
            }
            eq.context.resume?.();
            try { eq.source.disconnect(); } catch (_) {}
            for (const node of eq.nodes || []) {
                try { node.disconnect(); } catch (_) {}
            }
            if (eq.gain) {
                try { eq.gain.disconnect(); } catch (_) {}
            } else {
                eq.gain = eq.context.createGain();
            }
            const gainValue = Number.isFinite(Number(eq.gainValue)) ? Number(eq.gainValue) : 1;
            try { eq.gain.gain.setValueAtTime(gainValue, eq.context.currentTime || 0); } catch (_) {
                eq.gain.gain.value = gainValue;
            }
            eq.nodes = [];
            let current = eq.source;
            const q = profile.bandCount === 31 ? 4.2 : profile.bandCount === 15 ? 2.1 : profile.bandCount === 5 ? 0.9 : 1.35;
            if (active) {
                for (let i = 0; i < profile.bands.length; i++) {
                    const gain = profile.gains[i] || 0;
                    if (Math.abs(gain) <= 0.001) continue;
                    const filter = eq.context.createBiquadFilter();
                    filter.type = "peaking";
                    filter.frequency.value = profile.bands[i];
                    filter.Q.value = q;
                    filter.gain.value = gain;
                    current.connect(filter);
                    current = filter;
                    eq.nodes.push(filter);
                }
            }
            current.connect(eq.gain);
            eq.gain.connect(eq.context.destination);
        },
    'com.phoebe.app.player.installWebAudioProgressHandler' : (audio, callback) => { audio.onprogress = () => callback(); },
    'com.phoebe.app.player.webAudioHasActiveSource' : (audio) => !!(audio && audio.src),
    'com.phoebe.app.player.webAudioSourceMatchesUri' : (audio, uri) => {
            if (!audio || !uri) return false;
            const src = String(audio.src || "");
            const expected = String(uri || "");
            if (!src || !expected) return false;
            return src === expected || src.endsWith(expected) || expected.endsWith(src);
        },
    'com.phoebe.app.player.webCastAvailable' : () => {
    	        try {
    	            const context = globalThis.__phoebeCastGetContext?.() ||
    	                globalThis.cast?.framework?.CastContext?.getInstance?.() || null;
    	            if (context && globalThis.chrome?.cast) return true;
    	            const ua = String(globalThis.navigator?.userAgent || "");
    	            return /Chrome|Chromium|Edg\//.test(ua) && !/Firefox|Safari\/.*Version\//.test(ua);
    	        } catch (_) {
    	            return false;
    	        }
    	    },
    'com.phoebe.app.player.webCastInstallStatusListener' : (callback) => {
    	        const getState = () => globalThis.__phoebeCastState ||
    	            (globalThis.__phoebeCastState = { context: null, media: null, mediaListener: null, wrapped: false, lastSession: null, forceDisconnected: false });
    	        const state = getState();
    	        const getContext = () => {
    	            try {
    	                return globalThis.cast?.framework?.CastContext?.getInstance?.() || null;
    	            } catch (_) {
    	                return null;
    	            }
    	        };
    	        const getSession = () => {
    	            const state = getState();
    	            if (state.forceDisconnected) return null;
    	            const context = getContext();
    	            if (context) {
    	                const session = context.getCurrentSession?.() || null;
    	                state.lastSession = session;
    	                if (!session) {
    	                    state.media = null;
    	                    state.mediaListener = null;
    	                }
    	                return session;
    	            }
    	            const session = state.lastSession || null;
    	            return session;
    	        };
    	        const getMedia = () => {
    	            const state = getState();
    	            if (state.forceDisconnected) return null;
    	            const session = getSession();
    	            if (!session) {
    	                state.media = null;
    	                state.mediaListener = null;
    	                return null;
    	            }
    	            return session?.getMediaSession?.() || state.media || null;
    	        };
    	        state.callback = callback;
    	        const readStatus = () => {
    	            try {
    	                const context = getContext();
    	                const ua = String(globalThis.navigator?.userAgent || "");
    	                const chromeLike = /Chrome|Chromium|Edg\//.test(ua) && !/Firefox|Safari\/.*Version\//.test(ua);
    	                const available = (!!context && !!globalThis.chrome?.cast) || chromeLike;
    	                const session = getSession();
    	                const mediaSession = getMedia();
    	                const playerState = mediaSession?.playerState || "";
    	                const media = mediaSession?.media || {};
    	                const currentItem = Array.isArray(mediaSession?.items)
    	                    ? mediaSession.items.find((item) => item?.itemId === mediaSession.currentItemId)
    	                    : null;
    	                const mediaInfo = currentItem?.media || media;
    	                const currentTime = Number(mediaSession?.getEstimatedTime?.() ?? mediaSession?.currentTime ?? 0);
    	                const duration = Number(mediaInfo?.duration ?? mediaSession?.duration ?? 0);
    	                const customData = mediaInfo?.customData || {};
    	                const hasMedia = !!mediaInfo?.contentId ||
    	                    (Array.isArray(mediaSession?.items) && mediaSession.items.length > 0);
    	                const playerStates = globalThis.chrome?.cast?.media?.PlayerState || {};
    	                const idleReasons = globalThis.chrome?.cast?.media?.IdleReason || {};
    	                const idleReason = mediaSession?.idleReason || "";
    	                const isEnded = playerState === playerStates.IDLE &&
    	                    (!idleReason || idleReason === idleReasons.FINISHED || String(idleReason).toUpperCase() === "FINISHED");
    	                return JSON.stringify({
    	                    isAvailable: available,
    	                    isConnected: !!session,
    	                    hasMedia: hasMedia,
    	                    deviceName: session?.getCastDevice?.()?.friendlyName || null,
    	                    isPlaying: playerState === playerStates.PLAYING,
    	                    isBuffering: playerState === playerStates.BUFFERING,
    	                    positionMs: Number.isFinite(currentTime) ? Math.max(0, Math.round(currentTime * 1000)) : 0,
    	                    durationMs: Number.isFinite(duration) ? Math.max(0, Math.round(duration * 1000)) : 0,
    	                    trackId: customData.phoebeTrackId || null,
    	                    contentId: mediaInfo?.contentId || null,
    	                    isEnded: isEnded
    	                });
    	            } catch (error) {
    	                console.warn("Phoebe Chromecast status read failed.", error);
    	                return JSON.stringify({
    	                    isAvailable: false,
    	                    isConnected: false,
    	                    hasMedia: false
    	                });
    	            }
    	        };
            const notify = () => {
                try {
                    state.callback?.(readStatus());
                } catch (error) {
                    console.warn("Phoebe Chromecast status callback failed.", error);
                }
            };
    	        const errorMessage = (error, fallback) => {
    	            const rawCode = error?.code || error?.errorCode || error?.type || error?.reason || "";
    	            const code = String(rawCode || error?.description || "").toUpperCase();
    	            if (code.includes("CANCEL")) return "Chromecast selection was cancelled.";
    	            if (code.includes("TIMEOUT")) return "Chromecast did not respond in time.";
    	            const message = error?.message || error?.description || error?.details;
    	            const detail = message ? String(message) : "";
    	            if (rawCode && detail && !detail.includes(String(rawCode))) {
    	                return fallback + " (" + rawCode + ": " + detail + ")";
    	            }
    	            if (rawCode) return fallback + " (" + rawCode + ")";
    	            return detail || fallback;
    	        };
    	        const attachMediaListener = () => {
    	            const state = getState();
    	            const media = getMedia();
    	            if (state.media === media) return;
    	            if (state.media && state.mediaListener && typeof state.media.removeUpdateListener === "function") {
    	                try { state.media.removeUpdateListener(state.mediaListener); } catch (_) {}
    	            }
                state.media = media || null;
                state.mediaListener = media ? (() => notify()) : null;
                if (media && state.mediaListener && typeof media.addUpdateListener === "function") {
                    media.addUpdateListener(state.mediaListener);
                }
    	        };
    	        const installContextListeners = () => {
    	            const context = getContext();
    	            if (!context) {
    	                notify();
    	                return;
    	            }
    	            if (state.context !== context) {
                    state.context = context;
                    const eventTypes = globalThis.cast?.framework?.CastContextEventType || {};
                    const add = context.addEventListener?.bind(context);
                    add?.(eventTypes.CAST_STATE_CHANGED, () => notify());
                    add?.(eventTypes.SESSION_STATE_CHANGED, () => {
                        const currentSession = context.getCurrentSession?.() || null;
                        if (!state.forceDisconnected) {
                            state.lastSession = currentSession;
                        }
                        if (!currentSession) {
                            state.media = null;
                            state.mediaListener = null;
                        }
                        attachMediaListener();
                        notify();
                    });
                }
                attachMediaListener();
                notify();
            };
            globalThis.__phoebeCastReadStatus = readStatus;
            globalThis.__phoebeCastNotifyStatus = () => {
                attachMediaListener();
                notify();
            };
            globalThis.__phoebeCastErrorMessage = errorMessage;
            if (!state.wrapped) {
                const previous = globalThis.__onGCastApiAvailable;
                globalThis.__onGCastApiAvailable = (isAvailable) => {
    	                try {
    	                    if (typeof previous === "function") previous(isAvailable);
    	                } catch (error) {
    	                    console.warn("Phoebe Chromecast previous availability callback failed.", error);
    	                }
    	                installContextListeners();
    	            };
    	            state.wrapped = true;
    	        }
    	        globalThis.__phoebeCastGetState = getState;
    	        globalThis.__phoebeCastGetContext = getContext;
    	        globalThis.__phoebeCastGetSession = getSession;
    	        globalThis.__phoebeCastGetMedia = getMedia;
    	        installContextListeners();
    	    },
    'com.phoebe.app.player.webCastRequestSession' : (success, failure) => {
    	        try {
    	            const context = globalThis.__phoebeCastGetContext?.() ||
    	                globalThis.cast?.framework?.CastContext?.getInstance?.() || null;
    	            if (!context) {
    	                failure("Chromecast requires Chrome with Cast support.");
    	                return;
    	            }
    	            const complete = (session) => {
    	                    const state = globalThis.__phoebeCastGetState?.() ||
    	                        (globalThis.__phoebeCastState = { context: null, media: null, mediaListener: null, wrapped: false, lastSession: null, forceDisconnected: false });
    	                    state.forceDisconnected = false;
    	                    state.lastSession = session || context.getCurrentSession?.() || state.lastSession || null;
    	                    globalThis.__phoebeCastNotifyStatus?.();
    	                    success();
                    };
    	            const requested = context.requestSession?.();
    	            if (requested && typeof requested.then === "function") {
    	                requested.then(complete).catch((error) => {
                        globalThis.__phoebeCastNotifyStatus?.();
                        failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't start Chromecast session.") ||
                            "Couldn't start Chromecast session.");
                    });
    	            } else {
    	                complete(requested || context.getCurrentSession?.() || null);
    	            }
            } catch (error) {
                failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't start Chromecast session.") ||
                    "Couldn't start Chromecast session.");
            }
        },
    'com.phoebe.app.player.webCastDisconnect' : () => {
    	        let session = null;
    	        try {
    	            session = globalThis.__phoebeCastGetSession?.() || null;
    	            session?.endSession?.(true);
    	        } catch (_) {
    	        } finally {
    	            if (globalThis.__phoebeCastState) {
    	                globalThis.__phoebeCastState.forceDisconnected = true;
    	                globalThis.__phoebeCastState.lastSession = null;
    	                globalThis.__phoebeCastState.media = null;
    	                globalThis.__phoebeCastState.mediaListener = null;
    	            }
    	        }
    	    },
    'com.phoebe.app.player.webCastConnected' : () => {
    	        try {
    	            return !!globalThis.__phoebeCastGetSession?.();
    	        } catch (_) {
    	            return false;
    	        }
    	    },
    'com.phoebe.app.player.webCastLoadMedia' : (payload, success, failure) => {
    	        try {
    	            const mediaApi = globalThis.chrome?.cast?.media;
    	            const session = globalThis.__phoebeCastGetSession?.();
    	            if (!session || !mediaApi) {
    	                failure("Choose a Chromecast before casting.");
    	                return;
    	            }
    	            const requestPayload = JSON.parse(payload);
                const items = Array.isArray(requestPayload.items) ? requestPayload.items : [];
                const startIndex = Math.min(Math.max(Number(requestPayload.startIndex || 0), 0), Math.max(items.length - 1, 0));
                const startTime = Math.max(0, Number(requestPayload.startPositionMs || 0) / 1000);
                if (!items.length) {
                    failure("Choose songs before casting to Chromecast.");
                    return;
                }
    	            const toMediaInfo = (item) => {
    	                const mediaInfo = new mediaApi.MediaInfo(item.url, item.contentType || "audio/mpeg");
    	                mediaInfo.contentUrl = item.url;
    	                mediaInfo.streamType = item.isLiveStream
    	                    ? (mediaApi.StreamType?.LIVE || "LIVE")
    	                    : (mediaApi.StreamType?.BUFFERED || "BUFFERED");
    	                mediaInfo.duration = item.isLiveStream ? null : Math.max(0, Number(item.durationMs || 0)) / 1000;
    	                mediaInfo.customData = {
                        phoebeTrackId: item.trackId,
                        provider: item.provider,
                        title: item.title,
                        artist: item.artist,
                        album: item.album,
                        durationMs: item.durationMs,
                        streamUrl: item.streamUrl,
                        castUrl: item.url,
                        downloadUrl: item.downloadUrl,
                        thumbUrl: item.imageUrl,
                        filepath: item.filepath,
                        audioCodec: item.audioCodec
                    };
                    const metadata = new mediaApi.MusicTrackMediaMetadata();
    	                metadata.title = item.title || "Chromecast audio";
    	                metadata.artist = item.artist || "";
    	                metadata.albumName = item.album || "";
    	                if (item.imageUrl && (item.imageUrl.startsWith("http://") || item.imageUrl.startsWith("https://"))) {
    	                    metadata.images = typeof globalThis.chrome?.cast?.Image === "function"
    	                        ? [new globalThis.chrome.cast.Image(item.imageUrl)]
    	                        : [{ url: item.imageUrl }];
    	                }
    	                mediaInfo.metadata = metadata;
    	                return mediaInfo;
    	            };
                const queueItems = items.map((item, index) => {
                    const mediaInfo = toMediaInfo(item);
                    const queueItem = typeof mediaApi.QueueItem === "function"
                        ? new mediaApi.QueueItem(mediaInfo)
                        : { media: mediaInfo };
                    queueItem.media = queueItem.media || mediaInfo;
                    queueItem.autoplay = true;
                    queueItem.startTime = index === startIndex ? startTime : 0;
                    queueItem.customData = mediaInfo.customData;
                    return queueItem;
                });
    	            const makeLoadRequest = (includeQueue) => {
    	                const loadRequest = new mediaApi.LoadRequest(queueItems[startIndex].media);
    	                loadRequest.autoplay = true;
    	                loadRequest.currentTime = startTime;
    	                loadRequest.customData = queueItems[startIndex].media.customData;
    	                if (includeQueue && queueItems.length > 1 && typeof mediaApi.QueueData === "function") {
    	                    const queueData = new mediaApi.QueueData(
    	                        undefined,
    	                        "Phoebe Queue",
    	                        undefined,
    	                        mediaApi.RepeatMode?.REPEAT_OFF,
    	                        queueItems,
    	                        startIndex,
    	                        startTime
    	                    );
    	                    loadRequest.queueData = queueData;
    	                }
    	                return loadRequest;
    	            };
    	            const sendLoad = (includeQueue) => {
    	                const loadRequest = makeLoadRequest(includeQueue);
    	                globalThis.__phoebeLastCastLoadRequest = loadRequest;
    	                const loadResult = session.loadMedia(loadRequest);
    	                const loadPromise = loadResult && typeof loadResult.then === "function"
    	                    ? loadResult
    	                    : loadResult
    	                        ? Promise.resolve(loadResult)
    	                    : new Promise((resolve, reject) => {
    	                        setTimeout(() => {
    	                            const loaded = session.getMediaSession?.() || globalThis.__phoebeCastGetMedia?.() || null;
    	                            if (loaded) resolve(loaded);
    	                            else reject({ message: "Chromecast did not start this stream in time." });
    	                        }, 1500);
    	                    });
    	                const timeout = new Promise((_, reject) => {
    	                    setTimeout(() => reject({ message: "Chromecast did not start this stream in time." }), 15000);
    	                });
    	                return Promise.race([loadPromise, timeout]);
    	            };
    	            const loadWithFallback = sendLoad(queueItems.length > 1)
    	                .catch((queueError) => {
    	                    if (queueItems.length <= 1) throw queueError;
    	                    console.warn("Phoebe Chromecast queue load failed, retrying current item only.", queueError);
    	                    return sendLoad(false);
    	                });
    	            loadWithFallback.then(
    	                (mediaSession) => {
    	                    const state = globalThis.__phoebeCastGetState?.();
    	                    if (mediaSession && state) {
    	                        state.media = mediaSession;
    	                    }
    	                    globalThis.__phoebeCastNotifyStatus?.();
    	                    success();
    	                },
    	                (error) => {
    	                    globalThis.__phoebeCastNotifyStatus?.();
    	                    failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't load on Chromecast.") ||
    	                        "Couldn't load on Chromecast.");
    	                }
    	            );
            } catch (error) {
                failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't load on Chromecast.") ||
                    "Couldn't load on Chromecast.");
            }
        },
    'com.phoebe.app.player.webCastTogglePlayPause' : (success, failure) => {
    	        try {
    	            const media = globalThis.__phoebeCastGetMedia?.();
    	            if (!media || !globalThis.chrome?.cast?.media) {
    	                failure("No Chromecast media is loaded.");
    	                return;
                }
                const done = () => {
                    globalThis.__phoebeCastNotifyStatus?.();
                    success();
                };
                const fail = (error) => failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't control Chromecast playback.") ||
                    "Couldn't control Chromecast playback.");
                if (media.playerState === globalThis.chrome.cast.media.PlayerState.PLAYING) {
                    media.pause(null, done, fail);
                } else {
                    media.play(null, done, fail);
                }
            } catch (error) {
                failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't control Chromecast playback.") ||
                    "Couldn't control Chromecast playback.");
            }
        },
    'com.phoebe.app.player.webCastQueueNext' : (success, failure) => {
    	        try {
    	            const media = globalThis.__phoebeCastGetMedia?.();
    	            const hasReceiverQueue = Array.isArray(media?.items) && media.items.length > 1;
    	            if (!media || !hasReceiverQueue || typeof media.queueNext !== "function") {
    	                failure("Chromecast queue controls are not available.");
    	                return;
    	            }
                media.queueNext(() => {
                    globalThis.__phoebeCastNotifyStatus?.();
                    success();
                }, (error) => failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't skip Chromecast playback.") ||
                    "Couldn't skip Chromecast playback."));
            } catch (error) {
                failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't skip Chromecast playback.") ||
                    "Couldn't skip Chromecast playback.");
            }
        },
    'com.phoebe.app.player.webCastQueuePrevious' : (success, failure) => {
    	        try {
    	            const media = globalThis.__phoebeCastGetMedia?.();
    	            const hasReceiverQueue = Array.isArray(media?.items) && media.items.length > 1;
    	            if (!media || !hasReceiverQueue || typeof media.queuePrev !== "function") {
    	                failure("Chromecast queue controls are not available.");
    	                return;
    	            }
                media.queuePrev(() => {
                    globalThis.__phoebeCastNotifyStatus?.();
                    success();
                }, (error) => failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't skip Chromecast playback.") ||
                    "Couldn't skip Chromecast playback."));
            } catch (error) {
                failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't skip Chromecast playback.") ||
                    "Couldn't skip Chromecast playback.");
            }
        },
    'com.phoebe.app.player.webCastSeek' : (seconds, success, failure) => {
    	        try {
    	            const media = globalThis.__phoebeCastGetMedia?.();
    	            if (!media || !globalThis.chrome?.cast?.media) {
    	                failure("No Chromecast media is loaded.");
    	                return;
                }
                const request = new globalThis.chrome.cast.media.SeekRequest();
                request.currentTime = Math.max(0, Number(seconds || 0));
                media.seek(request, () => {
                    globalThis.__phoebeCastNotifyStatus?.();
                    success();
                }, (error) => failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't seek Chromecast playback.") ||
                    "Couldn't seek Chromecast playback."));
            } catch (error) {
                failure(globalThis.__phoebeCastErrorMessage?.(error, "Couldn't seek Chromecast playback.") ||
                    "Couldn't seek Chromecast playback.");
            }
        },
    'com.phoebe.app.player.webCastStatus' : () => {
    	        try {
    	            return globalThis.__phoebeCastReadStatus?.() || "{}";
    	        } catch (_) {
    	            return "{}";
    	        }
    	    },
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' }),
    'coil3.decode.WebWorkerRequest' : (id, buffer, width, height) => ({ id: id, data: buffer, w: width, h: height }),
    'coil3.decode.getSkikoMemory' : (skikoWasm) => skikoWasm.wasmExports.memory.buffer,
    'coil3.decode.id_$external_prop_getter' : (_this) => _this.id,
    'coil3.decode.kind_$external_prop_getter' : (_this) => _this.kind,
    'coil3.decode.buffer_$external_prop_getter' : (_this) => _this.buffer,
    'coil3.decode.id_$external_prop_getter_1' : (_this) => _this.id,
    'coil3.decode.message_$external_prop_getter' : (_this) => _this.message,
    'coil3.util.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'coil3.util.deref_$external_fun' : (_this, ) => _this.deref(),
    'com.phoebe.app.feature.playback.webInstallMediaSessionHandlers' : 
        (onNext, onPrevious, onSeekBackward, onSeekForward, onSeekTo) => {
            const session = globalThis.navigator?.mediaSession;
            if (!session) return;
            const set = (action, handler) => {
                try { session.setActionHandler(action, handler); } catch (_) {}
            };
            // Let Chrome keep native play/pause control over the active <audio> element.
            // Phoebe only supplies actions the browser cannot infer from the element.
            set("play", null);
            set("pause", null);
            set("stop", null);
            set("nexttrack", () => onNext());
            set("previoustrack", () => onPrevious());
            set("seekbackward", (event) => {
                const offset = Number(event?.seekOffset);
                onSeekBackward((Number.isFinite(offset) && offset > 0 ? offset : 10) * 1000);
            });
            set("seekforward", (event) => {
                const offset = Number(event?.seekOffset);
                onSeekForward((Number.isFinite(offset) && offset > 0 ? offset : 10) * 1000);
            });
            set("seekto", (event) => {
                const seekTime = Number(event?.seekTime);
                if (Number.isFinite(seekTime)) onSeekTo(Math.max(0, seekTime * 1000));
            });
        }
        ,
    'com.phoebe.app.feature.playback.webClearMediaSession' : 
        () => {
            const session = globalThis.navigator?.mediaSession;
            if (!session) return;
            const clear = (action) => {
                try { session.setActionHandler(action, null); } catch (_) {}
            };
            for (const action of [
                "play",
                "pause",
                "stop",
                "nexttrack",
                "previoustrack",
                "seekbackward",
                "seekforward",
                "seekto",
            ]) {
                clear(action);
            }
            try { session.metadata = null; } catch (_) {}
            try { session.playbackState = "none"; } catch (_) {}
            globalThis.__phoebeMediaSessionMetadataKey = "";
        }
        ,
    'com.phoebe.app.feature.playback.webUpdateMediaSession' : 
        (title, artist, album, artworkUrl, positionMs, durationMs, playing) => {
            const session = globalThis.navigator?.mediaSession;
            if (!session) return;

            const clean = (value) => String(value || "").trim();
            const nextTitle = clean(title);
            const nextArtist = clean(artist);
            const nextAlbum = clean(album);
            const nextArtworkUrl = clean(artworkUrl);
            const hasMetadata = !!(nextTitle || nextArtist || nextAlbum || nextArtworkUrl);

            if (!hasMetadata) {
                try { session.metadata = null; } catch (_) {}
                try { session.playbackState = "none"; } catch (_) {}
                globalThis.__phoebeMediaSessionMetadataKey = "";
                return;
            }

            const metadataKey = JSON.stringify([nextTitle, nextArtist, nextAlbum, nextArtworkUrl]);
            if (globalThis.__phoebeMediaSessionMetadataKey !== metadataKey && typeof MediaMetadata !== "undefined") {
                const artwork = nextArtworkUrl ? [
                    { src: nextArtworkUrl, sizes: "96x96" },
                    { src: nextArtworkUrl, sizes: "128x128" },
                    { src: nextArtworkUrl, sizes: "192x192" },
                    { src: nextArtworkUrl, sizes: "256x256" },
                    { src: nextArtworkUrl, sizes: "512x512" },
                ] : [];
                try {
                    session.metadata = new MediaMetadata({
                        title: nextTitle || "Phoebe",
                        artist: nextArtist,
                        album: nextAlbum,
                        artwork,
                    });
                    globalThis.__phoebeMediaSessionMetadataKey = metadataKey;
                } catch (_) {}
            }

            try { session.playbackState = playing ? "playing" : "paused"; } catch (_) {}

            const duration = Number(durationMs) / 1000;
            const rawPosition = Number(positionMs) / 1000;
            if (Number.isFinite(duration) && duration > 0 && typeof session.setPositionState === "function") {
                const position = Number.isFinite(rawPosition) ? Math.min(Math.max(0, rawPosition), duration) : 0;
                try {
                    session.setPositionState({
                        duration,
                        playbackRate: 1,
                        position,
                    });
                } catch (_) {}
            }
        }
        ,
    'com.phoebe.app.feature.playback.butterchurnNewHostId' : () => 'phoebe-butterchurn-' + Math.floor(Math.random() * 1e9),
    'com.phoebe.app.feature.playback.butterchurnStop' : 
        (hostId) => {
          try {
            const g = globalThis;
            if (g.__phoebeButterchurn) delete g.__phoebeButterchurn[hostId];
            const el = document.getElementById(hostId);
            if (el) el.remove();
          } catch (e) {}
        }
        ,
    'com.phoebe.app.feature.playback.butterchurnEnsureStarted' : 
        (hostId, x, y, width, height) => {
          try {
            const g = globalThis;
            g.__phoebeButterchurn = g.__phoebeButterchurn || {};
            const dpr = window.devicePixelRatio || 1;
            const cssW = Math.max(2, Math.round((Number(width) || 0) / dpr));
            const cssH = Math.max(2, Math.round((Number(height) || 0) / dpr));
            const cssX = Math.max(0, (Number(x) || 0) / dpr);
            const cssY = Math.max(0, (Number(y) || 0) / dpr);

            let canvas = document.getElementById(hostId);
            if (!canvas) {
              canvas = document.createElement('canvas');
              canvas.id = hostId;
              canvas.style.position = 'fixed';
              canvas.style.zIndex = '10';
              canvas.style.pointerEvents = 'none';
              canvas.style.border = '0';
              canvas.style.background = '#000';
              document.body.appendChild(canvas);
            }
            canvas.style.left = cssX + 'px';
            canvas.style.top = cssY + 'px';
            canvas.style.width = cssW + 'px';
            canvas.style.height = cssH + 'px';
            canvas.width = Math.max(2, Math.round(cssW * dpr));
            canvas.height = Math.max(2, Math.round(cssH * dpr));

            const existing = g.__phoebeButterchurn[hostId];
            if (existing && existing.visualizer) {
              if (typeof existing.visualizer.setRendererSize === 'function') {
                existing.visualizer.setRendererSize(cssW, cssH);
              }
              return;
            }

            const Butterchurn = g.butterchurn && (g.butterchurn.default || g.butterchurn);
            if (!Butterchurn || typeof Butterchurn.createVisualizer !== 'function') {
              console.warn('butterchurn missing createVisualizer', g.butterchurn);
              return;
            }

            const AudioCtx = window.AudioContext || window.webkitAudioContext;
            if (!AudioCtx) {
              console.warn('butterchurn: AudioContext unavailable');
              return;
            }
            const eq = g.__phoebeEqualizer;
            const audioCtx = (eq && eq.context) || g.__phoebeAudioCtx || new AudioCtx();
            if (!g.__phoebeAudioCtx) g.__phoebeAudioCtx = audioCtx;
            const resume = () => {
              try { audioCtx.resume && audioCtx.resume(); } catch (e) {}
            };
            resume();
            window.addEventListener('pointerdown', resume, { once: false });

            const visualizer = Butterchurn.createVisualizer(audioCtx, canvas, {
              width: cssW,
              height: cssH,
              pixelRatio: dpr
            });
            const entry = { visualizer: visualizer, playing: false, connectedAudio: null };
            g.__phoebeButterchurn[hostId] = entry;

            const connectRealAudio = () => {
              if (typeof visualizer.connectAudio !== 'function') return;
              try {
                let liveEq = g.__phoebeEqualizer;
                const audio = g.__phoebeActiveAudio;
                if (!audio) return;
                if (entry.connectedAudio === audio) return;
                // Build the same MediaElementSource → gain graph the equalizer uses, so
                // playback keeps working and Butterchurn can tap real media PCM.
                if (!liveEq || liveEq.audio !== audio || !liveEq.gain) {
                  const Ctx = window.AudioContext || window.webkitAudioContext;
                  if (!Ctx) return;
                  const context = (liveEq && liveEq.context) || g.__phoebeAudioCtx || new Ctx();
                  if (!g.__phoebeAudioCtx) g.__phoebeAudioCtx = context;
                  let source = liveEq && liveEq.audio === audio ? liveEq.source : null;
                  if (!source) {
                    try {
                      source = context.createMediaElementSource(audio);
                    } catch (e) {
                      return;
                    }
                  }
                  const gain = context.createGain();
                  gain.gain.value = (liveEq && liveEq.audio === audio && Number.isFinite(liveEq.gainValue))
                    ? liveEq.gainValue
                    : 1;
                  try { source.disconnect(); } catch (e) {}
                  source.connect(gain);
                  gain.connect(context.destination);
                  liveEq = {
                    audio: audio,
                    context: context,
                    source: source,
                    nodes: [],
                    gain: gain,
                    gainValue: gain.gain.value
                  };
                  g.__phoebeEqualizer = liveEq;
                }
                try { liveEq.context && liveEq.context.resume && liveEq.context.resume(); } catch (e) {}
                visualizer.connectAudio(liveEq.gain);
                entry.connectedAudio = audio;
              } catch (e) {
                console.warn('butterchurn connectAudio failed', e);
              }
            };
            connectRealAudio();
            entry.connectRealAudio = connectRealAudio;

            const loop = () => {
              const current = g.__phoebeButterchurn[hostId];
              if (!current || !current.visualizer) return;
              if (current.playing) {
                try { current.connectRealAudio && current.connectRealAudio(); } catch (e) {}
                try { current.visualizer.render(); } catch (e) {}
              }
              requestAnimationFrame(loop);
            };
            requestAnimationFrame(loop);
          } catch (e) {
            console.warn('butterchurn start failed', e);
          }
        }
        ,
    'com.phoebe.app.feature.playback.butterchurnLoadPreset' : 
        (hostId, presetData, presetPath, locked, isPlaying) => {
          try {
            const g = globalThis;
            const entry = g.__phoebeButterchurn && g.__phoebeButterchurn[hostId];
            if (!entry || !entry.visualizer) return;
            const v = entry.visualizer;
            entry.playing = !!isPlaying;
            if (entry.playing) {
              try { entry.connectRealAudio && entry.connectRealAudio(); } catch (e) {}
            }
            const blend = locked ? 0 : 2.0;
            const apply = (obj) => {
              try { v.loadPreset(obj, blend); } catch (e) {
                console.warn('butterchurn loadPreset apply failed', e);
              }
            };
            if (presetData && typeof presetData === 'string' && presetData.trim().startsWith('{')) {
              apply(JSON.parse(presetData));
              return;
            }
            const path = (presetPath && String(presetPath).trim()) || '';
            if (path) {
              const url = path.startsWith('/') || path.startsWith('http') ? path : ('/' + path);
              fetch(url).then((r) => {
                if (!r.ok) throw new Error('HTTP ' + r.status + ' for ' + url);
                return r.text();
              }).then((text) => {
                apply(JSON.parse(text));
              }).catch((e) => {
                console.warn('butterchurn fetch preset failed', e);
              });
              return;
            }
            const packsApi = g.butterchurnPresets && (g.butterchurnPresets.default || g.butterchurnPresets);
            let packs = null;
            if (typeof packsApi === 'function') {
              packs = packsApi();
            } else if (packsApi && typeof packsApi.getPresets === 'function') {
              packs = packsApi.getPresets();
            }
            if (packs) {
              const keys = Object.keys(packs);
              if (keys.length) {
                const preferred = keys.find((k) => /geiss|flexi|martin/i.test(k)) || keys[0];
                apply(packs[preferred]);
              }
            }
          } catch (e) {
            console.warn('butterchurn loadPreset failed', e);
          }
        }
        ,
    'com.phoebe.app.feature.playback.butterchurnSetAllOverlaysSuppressed' : 
        (suppressed) => {
          try {
            const hide = !!suppressed;
            document.querySelectorAll('canvas[id^="phoebe-butterchurn-"]').forEach((canvas) => {
              canvas.style.display = hide ? 'none' : 'block';
              canvas.style.visibility = hide ? 'hidden' : 'visible';
              canvas.style.pointerEvents = 'none';
              if (hide) {
                canvas.style.zIndex = '0';
              } else {
                canvas.style.zIndex = '10';
              }
            });
          } catch (e) {}
        }
        ,
    'com.phoebe.app.feature.radio.createRadioMapIframe' : 
        (html, onSelected, onPlay, onZoomChanged, onViewportChanged) => {
          const id = "phoebe-radio-map-" + Math.random().toString(36).slice(2);
          const iframe = document.createElement("iframe");
          iframe.id = id;
          iframe.srcdoc = html;
          iframe.setAttribute("title", "Radio map");
          iframe.style.position = "fixed";
          iframe.style.left = "0px";
          iframe.style.top = "0px";
          iframe.style.width = "0px";
          iframe.style.height = "0px";
          iframe.style.border = "0";
          iframe.style.borderRadius = "8px";
          iframe.style.overflow = "hidden";
          iframe.style.background = "#080b12";
          iframe.style.zIndex = "2";
          iframe.style.pointerEvents = "auto";
          iframe.style.setProperty("-webkit-tap-highlight-color", "transparent");
          document.body.appendChild(iframe);
          const bridgeHost = typeof window !== "undefined" ? window : globalThis;
          const bridge = bridgeHost.PhoebeRadioMap || {};
          bridgeHost.PhoebeRadioMap = bridge;
          globalThis.PhoebeRadioMap = bridge;
          bridge.latestRadioMapData = bridge.latestRadioMapData || { markers: null, selectedId: null, startingIds: [] };
          bridge.getLatestData = () => bridge.latestRadioMapData;
          bridge.selectItem = (itemId) => onSelected(String(itemId || ""));
          bridge.playItem = (itemId) => onPlay(String(itemId || ""));
          bridge.zoomChanged = (zoom) => {
            const parsed = Number(zoom);
            if (Number.isFinite(parsed)) onZoomChanged(parsed);
          };
          bridge.viewportChanged = (north, south, east, west, zoom) => {
            const parsedNorth = Number(north);
            const parsedSouth = Number(south);
            const parsedEast = Number(east);
            const parsedWest = Number(west);
            const parsedZoom = Number(zoom);
            if ([parsedNorth, parsedSouth, parsedEast, parsedWest, parsedZoom].every(Number.isFinite)) {
              onViewportChanged(parsedNorth, parsedSouth, parsedEast, parsedWest, parsedZoom);
            }
          };
          const handleMessage = (event) => {
            const data = event.data || {};
            if (data.phoebeRadioMap !== true) return;
            const itemId = String(data.itemId || "");
            if (data.action === "selectItem") {
              bridge.selectItem(itemId);
            } else if (data.action === "playItem") {
              bridge.playItem(itemId);
            } else if (data.action === "zoomChanged") {
              bridge.zoomChanged(data.zoom);
            } else if (data.action === "viewportChanged" && data.viewport) {
              bridge.viewportChanged(data.viewport.north, data.viewport.south, data.viewport.east, data.viewport.west, data.viewport.zoom);
            }
          };
          window.addEventListener("message", handleMessage);
          bridge.iframeMessageHandlers = bridge.iframeMessageHandlers || {};
          bridge.iframeMessageHandlers[id] = handleMessage;
          return id;
        }
        ,
    'com.phoebe.app.feature.radio.__convertKotlinClosureToJsClosure_((Double,Double,Double,Double,Double)->Unit)' : (f) => getCachedJsObject(f, (p0, p1, p2, p3, p4) => wasmExports['__callFunction_((Double,Double,Double,Double,Double)->Unit)'](f, p0, p1, p2, p3, p4)),
    'com.phoebe.app.feature.radio.removeRadioMapIframe' : 
        (id) => {
          const iframe = document.getElementById(id);
          const bridgeHost = typeof window !== "undefined" ? window : globalThis;
          const bridge = bridgeHost.PhoebeRadioMap || {};
          const handleMessage = bridge.iframeMessageHandlers && bridge.iframeMessageHandlers[id];
          if (handleMessage) {
            window.removeEventListener("message", handleMessage);
            delete bridge.iframeMessageHandlers[id];
          }
          if (iframe) iframe.remove();
        }
        ,
    'com.phoebe.app.feature.radio.updateRadioMapIframeBounds' : 
        (id, x, y, width, height) => {
          const iframe = document.getElementById(id);
          if (!iframe) return;
          const scale = window.devicePixelRatio || 1;
          const left = Math.max(0, (Number(x) || 0) / scale);
          const top = Math.max(0, (Number(y) || 0) / scale);
          const requestedWidth = Math.max(0, (Number(width) || 0) / scale);
          const requestedHeight = Math.max(0, (Number(height) || 0) / scale);
          const right = Math.min(window.innerWidth || left, left + requestedWidth);
          const bottom = Math.min(window.innerHeight || top, top + requestedHeight);
          const clippedWidth = Math.max(0, right - left);
          const clippedHeight = Math.max(0, bottom - top);
          iframe.dataset.phoebeMapLeft = String(left);
          iframe.dataset.phoebeMapTop = String(top);
          iframe.dataset.phoebeMapWidth = String(clippedWidth);
          iframe.dataset.phoebeMapHeight = String(clippedHeight);
          const bridgeHost = typeof window !== "undefined" ? window : globalThis;
          const bridge = bridgeHost.PhoebeRadioMap || {};
          bridgeHost.PhoebeRadioMap = bridge;
          globalThis.PhoebeRadioMap = bridge;
          const occlusionTop = bridge.occlusionTopPx == null ? null : Math.max(0, Number(bridge.occlusionTopPx) / scale);
          const occludedBottom = Math.min(bottom, occlusionTop == null ? bottom : occlusionTop);
          const occludedHeight = Math.max(0, occludedBottom - top);
          iframe.style.left = left + "px";
          iframe.style.top = top + "px";
          iframe.style.width = clippedWidth + "px";
          iframe.style.height = occludedHeight + "px";
          iframe.style.display = clippedWidth > 0 && occludedHeight > 0 ? "block" : "none";
          if (iframe.contentWindow) {
            iframe.contentWindow.dispatchEvent(new Event("resize"));
          }
        }
        ,
    'com.phoebe.app.feature.radio.updateRadioMapIframeData' : 
        (id, jsonString) => {
          const markers = JSON.parse(jsonString);
          const bridgeHost = typeof window !== "undefined" ? window : globalThis;
          const bridge = bridgeHost.PhoebeRadioMap || {};
          bridgeHost.PhoebeRadioMap = bridge;
          globalThis.PhoebeRadioMap = bridge;
          const latest = bridge.latestRadioMapData || { markers: null, selectedId: null, startingIds: [] };
          latest.markers = markers;
          bridge.latestRadioMapData = latest;
          bridge.getLatestData = () => bridge.latestRadioMapData;
          const iframe = document.getElementById(id);
          if (iframe && iframe.contentWindow && iframe.contentWindow.updateRadioMapMarkers) {
            iframe.contentWindow.updateRadioMapMarkers(markers, latest.selectedId);
          }
        }
        ,
    'com.phoebe.app.feature.radio.updateRadioMapIframeSelection' : 
        (id, selectedId) => {
          const nextSelectedId = selectedId == null ? null : String(selectedId);
          const bridgeHost = typeof window !== "undefined" ? window : globalThis;
          const bridge = bridgeHost.PhoebeRadioMap || {};
          bridgeHost.PhoebeRadioMap = bridge;
          globalThis.PhoebeRadioMap = bridge;
          const latest = bridge.latestRadioMapData || { markers: null, selectedId: null, startingIds: [] };
          latest.selectedId = nextSelectedId;
          bridge.latestRadioMapData = latest;
          bridge.getLatestData = () => bridge.latestRadioMapData;
          const iframe = document.getElementById(id);
          if (iframe && iframe.contentWindow && iframe.contentWindow.updateRadioMapSelection) {
            iframe.contentWindow.updateRadioMapSelection(nextSelectedId);
          }
        }
        ,
    'com.phoebe.app.feature.radio.updateRadioMapIframeStartingStationIds' : 
        (id, startingIdsJson) => {
          const startingIds = JSON.parse(startingIdsJson);
          const bridgeHost = typeof window !== "undefined" ? window : globalThis;
          const bridge = bridgeHost.PhoebeRadioMap || {};
          bridgeHost.PhoebeRadioMap = bridge;
          globalThis.PhoebeRadioMap = bridge;
          const latest = bridge.latestRadioMapData || { markers: null, selectedId: null, startingIds: [] };
          latest.startingIds = startingIds;
          bridge.latestRadioMapData = latest;
          bridge.getLatestData = () => bridge.latestRadioMapData;
          const iframe = document.getElementById(id);
          if (iframe && iframe.contentWindow && iframe.contentWindow.setRadioMapStartingStationIds) {
            iframe.contentWindow.setRadioMapStartingStationIds(startingIds);
          }
        }
        ,
    'com.phoebe.app.installPhoebePopStateListener' : 
        (callback) => {
          const listener = () => callback(location.pathname || "/");
          if (globalThis.__phoebePopStateListener) {
            window.removeEventListener("popstate", globalThis.__phoebePopStateListener);
          }
          globalThis.__phoebePopStateListener = listener;
          window.addEventListener("popstate", listener);
        }
        ,
    'com.phoebe.app.removePhoebePopStateListener' : 
        () => {
          if (globalThis.__phoebePopStateListener) {
            window.removeEventListener("popstate", globalThis.__phoebePopStateListener);
            globalThis.__phoebePopStateListener = null;
          }
        }
        ,
    'com.phoebe.app.updatePhoebeBrowserPath' : 
        (path, replace) => {
          const nextPath = path || "/";
          if ((location.pathname || "/") === nextPath) return;
          const method = replace ? "replaceState" : "pushState";
          history[method](null, "", nextPath);
        }
        ,
    'com.phoebe.app.isWebDocumentVisible' : () => !document.hidden,
    'com.phoebe.app.e2e.publishWasmE2eResults' : (passed, message) => {
            globalThis.phoebeE2eResults = { passed: !!passed, message: String(message ?? "") };
        },
    'com.phoebe.app.e2e.publishWasmE2eReady' : (ready, message) => {
            globalThis.phoebeE2eReady = !!ready;
            globalThis.phoebeE2eReadyMessage = String(message ?? "");
        },
    'com.phoebe.app.e2e.installWasmCastE2eMock' : 
        () => {
            delete globalThis.__phoebeCastState;
            delete globalThis.__phoebeCastReadStatus;
            delete globalThis.__phoebeCastNotifyStatus;
            delete globalThis.__phoebeCastErrorMessage;
            delete globalThis.__phoebeCastGetState;
            delete globalThis.__phoebeCastGetContext;
            delete globalThis.__phoebeCastGetSession;
            delete globalThis.__phoebeCastGetMedia;
            let connected = false;
            let mediaSession = null;
            let nextItemId = 1;
            const mediaApi = {
                DEFAULT_MEDIA_RECEIVER_APP_ID: "CC1AD845",
                PlayerState: { PLAYING: "PLAYING", BUFFERING: "BUFFERING", PAUSED: "PAUSED" },
                StreamType: { BUFFERED: "BUFFERED" },
                RepeatMode: { REPEAT_OFF: "REPEAT_OFF" },
                MediaInfo: function(contentId, contentType) {
                    this.contentId = contentId;
                    this.contentType = contentType;
                },
                MusicTrackMediaMetadata: function() {},
                LoadRequest: function(media) {
                    this.media = media;
                },
                QueueItem: function(media) {
                    this.media = media;
                    this.itemId = nextItemId++;
                },
                QueueData: function() {},
                SeekRequest: function() {}
            };
            const session = {
                getCastDevice: () => ({ friendlyName: "Mock TV" }),
                getMediaSession: () => mediaSession,
                loadMedia: (request) => {
                    const items = request.queueData?.items || [{ media: request.media, itemId: nextItemId++ }];
                    const index = Math.max(0, Math.min(Number(request.queueData?.startIndex || 0), items.length - 1));
                    mediaSession = {
                        playerState: mediaApi.PlayerState.PLAYING,
                        media: items[index].media,
                        items,
                        currentItemId: items[index].itemId,
                        currentTime: Number(request.currentTime || 0),
                        duration: Number(items[index].media?.duration || 0),
                        getEstimatedTime: () => mediaSession.currentTime,
                        addUpdateListener: () => {},
                        removeUpdateListener: () => {},
                        play: (_request, success) => {
                            mediaSession.playerState = mediaApi.PlayerState.PLAYING;
                            success?.();
                        },
                        pause: (_request, success) => {
                            mediaSession.playerState = mediaApi.PlayerState.PAUSED;
                            success?.();
                        },
                        seek: (seekRequest, success) => {
                            mediaSession.currentTime = Number(seekRequest.currentTime || 0);
                            success?.();
                        },
                        queueNext: (success) => success?.(),
                        queuePrev: (success) => success?.()
                    };
                    globalThis.__phoebeCastE2eLoadedContentId = items[index].media?.contentId || "";
                    return Promise.resolve();
                },
                endSession: () => {
                    connected = false;
                    mediaSession = null;
                }
            };
            const context = {
                getCastState: () => "CONNECTED",
                getCurrentSession: () => connected ? session : null,
                requestSession: () => {
                    connected = true;
                    return session;
                },
                addEventListener: () => {}
            };
            globalThis.chrome = {
                cast: {
                    AutoJoinPolicy: { ORIGIN_SCOPED: "ORIGIN_SCOPED" },
                    media: mediaApi
                }
            };
            globalThis.cast = {
                framework: {
                    CastState: { NO_DEVICES_AVAILABLE: "NO_DEVICES_AVAILABLE" },
                    CastContextEventType: {
                        CAST_STATE_CHANGED: "CAST_STATE_CHANGED",
                        SESSION_STATE_CHANGED: "SESSION_STATE_CHANGED"
                    },
                    CastContext: {
                        getInstance: () => context
                    }
                }
            };
        }
        ,
    'com.phoebe.app.e2e.wasmCastE2eLoadedContentId' : () => String(globalThis.__phoebeCastE2eLoadedContentId || ''),
    'com.phoebe.app.e2e.seedPlayableWavBrowserLocalFolder' : 
        () => {
            const store = globalThis.__phoebeLocalFileStore ||
                (globalThis.__phoebeLocalFileStore = { folders: new Map(), files: new Map() });
            const id = "web-playback-regression-folder";
            const folderLabel = "Playback Regression";
            const rootUri = "phoebe-web-folder://" + id + "/" + encodeURIComponent(folderLabel);
            for (const key of Array.from(store.files.keys())) {
                if (String(key).startsWith("phoebe-web-file://" + id + "/")) {
                    store.files.delete(key);
                }
            }
            const sampleRate = 44100;
            const seconds = 0.65;
            const sampleCount = Math.floor(sampleRate * seconds);
            const dataBytes = sampleCount * 2;
            const bytes = new Uint8Array(44 + dataBytes);
            const view = new DataView(bytes.buffer);
            const text = (offset, value) => {
                for (let i = 0; i < value.length; i++) bytes[offset + i] = value.charCodeAt(i);
            };
            text(0, "RIFF");
            view.setUint32(4, 36 + dataBytes, true);
            text(8, "WAVE");
            text(12, "fmt ");
            view.setUint32(16, 16, true);
            view.setUint16(20, 1, true);
            view.setUint16(22, 1, true);
            view.setUint32(24, sampleRate, true);
            view.setUint32(28, sampleRate * 2, true);
            view.setUint16(32, 2, true);
            view.setUint16(34, 16, true);
            text(36, "data");
            view.setUint32(40, dataBytes, true);
            for (let i = 0; i < sampleCount; i++) {
                const envelope = Math.min(1, i / 400) * Math.min(1, (sampleCount - i) / 400);
                const sample = Math.round(Math.sin((2 * Math.PI * 440 * i) / sampleRate) * 0.26 * envelope * 32767);
                view.setInt16(44 + i * 2, sample, true);
            }
            const relativePath = "alpha.wav";
            const file = new File([bytes], relativePath, { type: "audio/wav", lastModified: 1234 });
            const uri = "phoebe-web-file://" + id + "/" + relativePath;
            const stored = {
                file,
                folderId: id,
                folderLabel,
                uri,
                objectUrl: null,
                relativePath,
                name: relativePath,
                parentPath: "",
                ext: "wav"
            };
            store.files.set(uri, stored);
            store.folders.set(id, { id, rootUri, label: folderLabel, files: [stored], textFiles: new Map() });
            return rootUri;
        }
        ,
    'com.phoebe.app.e2e.installWasmPlaybackRegressionButton' : 
        (label, callback) => {
            const id = "phoebe-web-playback-regression-play";
            let button = document.getElementById(id);
            if (!button) {
                button = document.createElement("button");
                button.id = id;
                button.style.position = "fixed";
                button.style.top = "12px";
                button.style.left = "12px";
                button.style.zIndex = "2147483647";
                button.style.padding = "10px 14px";
                button.style.borderRadius = "8px";
                button.style.border = "1px solid #aaa";
                button.style.background = "#111";
                button.style.color = "#fff";
                button.style.font = "14px system-ui, sans-serif";
                document.body.appendChild(button);
            }
            button.textContent = String(label || "Play");
            button.disabled = false;
            button.onclick = () => callback();
        }
        ,
    'com.phoebe.app.e2e.removeWasmPlaybackRegressionButton' : 
        () => {
            const button = document.getElementById("phoebe-web-playback-regression-play");
            if (button) {
                button.onclick = null;
                try { button.remove(); } catch (_) {}
            }
        }
        ,
    'com.phoebe.app.ui.setPhoebeRadioMapOcclusionTop' : 
        (sheetTopPx) => {
          const bridgeHost = typeof window !== "undefined" ? window : globalThis;
          const bridge = bridgeHost.PhoebeRadioMap || {};
          bridgeHost.PhoebeRadioMap = bridge;
          globalThis.PhoebeRadioMap = bridge;
          const parsed = Number(sheetTopPx);
          bridge.occlusionTopPx = Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
          const scale = window.devicePixelRatio || 1;

          const applyBounds = (iframe) => {
            const requestedLeft = Number(iframe.dataset.phoebeMapLeft || 0);
            const requestedTop = Number(iframe.dataset.phoebeMapTop || 0);
            const requestedWidth = Number(iframe.dataset.phoebeMapWidth || 0);
            const requestedHeight = Number(iframe.dataset.phoebeMapHeight || 0);
            const requestedRight = requestedLeft + requestedWidth;
            const requestedBottom = requestedTop + requestedHeight;
            const viewportRight = window.innerWidth || requestedRight;
            const viewportBottom = window.innerHeight || requestedBottom;
            const occlusionTop = bridge.occlusionTopPx == null ? null : Math.max(0, Number(bridge.occlusionTopPx) / scale);
            const clippedRight = Math.min(viewportRight, requestedRight);
            const clippedBottom = Math.min(viewportBottom, requestedBottom, occlusionTop == null ? requestedBottom : occlusionTop);
            const clippedWidth = Math.max(0, clippedRight - requestedLeft);
            const clippedHeight = Math.max(0, clippedBottom - requestedTop);
            iframe.style.left = requestedLeft + "px";
            iframe.style.top = requestedTop + "px";
            iframe.style.width = clippedWidth + "px";
            iframe.style.height = clippedHeight + "px";
            iframe.style.display = clippedWidth > 0 && clippedHeight > 0 ? "block" : "none";
            if (iframe.contentWindow) {
              iframe.contentWindow.dispatchEvent(new Event("resize"));
            }
          };

          document.querySelectorAll('iframe[id^="phoebe-radio-map-"]').forEach(applyBounds);
        }

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    